import React from 'react';
import loadable from '@loadable/component';

import getPageDataLoadingAPI from '../containers/pageDataLoadingAPI';
import NotFoundPage from '../containers/NotFoundPage/NotFoundPage';
import PreviewResolverPage from '../containers/PreviewResolverPage/PreviewResolverPage';

const LOCALES = ["el", "de", "ar"];

const createLocalizedRoutes = (config) => {
  const { path, ...rest } = config;

  return [
    // default (no locale prefix)
    {
      path,
      ...rest,
    },

    // localized versions
    ...LOCALES.map((lng) => ({
      path: `/${lng}${path}`,
      ...rest,
    })),
  ];
};



// routeConfiguration needs to initialize containers first
// Otherwise, components will import form container eventually and
// at that point css bundling / imports will happen in wrong order.
import { NamedRedirect } from '../components';

const pageDataLoadingAPI = getPageDataLoadingAPI();

const AuthenticationPage = loadable(() => import(/* webpackChunkName: "AuthenticationPage" */ '../containers/AuthenticationPage/AuthenticationPage'));
const MobileAuthPage = loadable(() => import(/* webpackChunkName: "MobileAuthPage" */ '../containers/MobileAuthPage/MobileAuthPage'));
const AiPage = loadable(() => import(/* webpackChunkName: "AiPage" */ '../containers/AiPage/AiPage'));
const EmployersPage = loadable(() => import(/* webpackChunkName: "EmployersPage" */ '../containers/EmployersPage/EmployersPage'));
const FemaleHealthProgramPage = loadable(() => import(/* webpackChunkName: "FemaleHealthProgramPage" */ '../containers/FemaleHealthProgramPage/FemaleHealthProgramPage'));
const HospitalsAndClinicsPage = loadable(() => import(/* webpackChunkName: "HospitalsAndClinicsPage" */ '../containers/HospitalsAndClinicsPage/HospitalsAndClinicsPage'));
const HealthPlansPage = loadable(() => import(/* webpackChunkName: "HealthPlansPage" */ '../containers/HealthPlansPage/HealthPlansPage'));
const CookiePolicy = loadable(() => import(/* webpackChunkName: "CookiePolicy" */ '../containers/CookiePolicy/CookiePolicy'));
const ImpressumPage = loadable(() => import(/* webpackChunkName: "Impressum" */ '../containers/Impressum/Impressum'));
const CheckoutPage = loadable(() => import(/* webpackChunkName: "CheckoutPage" */ '../containers/CheckoutPage/CheckoutPage'));
const CMSPage = loadable(() => import(/* webpackChunkName: "CMSPage" */ '../containers/CMSPage/CMSPage'));
const ContactDetailsPage = loadable(() => import(/* webpackChunkName: "ContactDetailsPage" */ '../containers/ContactDetailsPage/ContactDetailsPage'));
const DashboardPage = loadable(() => import(/* webpackChunkName: "DashboardPage" */ '../containers/DashboardPage/DashboardPage'));
const DeleteAccountPage = loadable(() => import(/* webpackChunkName: "DeleteAccountPage" */ '../containers/DeleteAccountPage/DeleteAccountPage'));
const UnsubscribePage = loadable(() => import(/* webpackChunkName: "UnsubscribePage" */ '../containers/UnsubscribePage/UnsubscribePage'));
const DoctorsPaymentPage = loadable(() => import(/* webpackChunkName: "DoctorsPaymentPage" */ '../containers/DoctorsPaymentPage/DoctorsPaymentPage'));
const DoctorOnboardingPage = loadable(() => import(/* webpackChunkName: "DoctorOnboardingPage" */ '../containers/DoctorOnboardingPage/DoctorOnboardingPage'));
const EditListingPage = loadable(() => import(/* webpackChunkName: "EditListingPage" */ '../containers/EditListingPage/EditListingPage'));
const TestPage = loadable(() => import(/* webpackChunkName: "TestPage" */ '../containers/TestPage/TestPage'));
const EmailVerificationPage = loadable(() => import(/* webpackChunkName: "EmailVerificationPage" */ '../containers/EmailVerificationPage/EmailVerificationPage'));
const InboxPage = loadable(() => import(/* webpackChunkName: "InboxPage" */ '../containers/InboxPage/InboxPage'));
const LandingPatientPage = loadable(() => import(/* webpackChunkName: "LandingPatientPage" */ '../containers/LandingPatientPage/LandingPatientPage'));
const SearchContentPage = loadable(() => import(/* webpackChunkName: "SearchContentPage" */ '../containers/SearchContentPage/SearchContentPage'));
const MenopauseResourcePage = loadable(() => import(/* webpackChunkName: "MenopauseResourcePage" */ '../containers/MenopauseResourcePage/MenopauseResourcePage'));
const Homepage = loadable(() => import(/* webpackChunkName: "Homepage" */ '../containers/Homepage/Homepage'));
const QuestionsPage = loadable(() => import(/* webpackChunkName: "QuestionsPage" */ '../containers/QuestionsPage/QuestionsPage'));
const UpcommingEventPage = loadable(() => import(/* webpackChunkName: "UpcommingEventPage" */ '../containers/UpcommingEventPage/UpcommingEventPage'));

const LandingPage = loadable(() => import(/* webpackChunkName: "LandingPage" */ '../containers/LandingPage/LandingPage'));
const MenopausePage = loadable(() => import(/* webpackChunkName: "MenopausePage" */ '../containers/MenopausePage/MenopausePage'));
const OurMenopauseJourneyPage = loadable(() => import(/* webpackChunkName: "OurMenopauseJourneyPage" */ '../containers/OurMenopauseJourneyPage/OurMenopauseJourneyPage'));
const MenopauseLandingPage = loadable(() => import(/* webpackChunkName: "MenopauseLandingPage" */ '../containers/MenopauseLandingPage/MenopauseLandingPage'));
const SexLandingPage = loadable(() => import(/* webpackChunkName: "SexLandingPage" */ '../containers/SexLandingPage/SexLandingPage'));
const SleepPage = loadable(() => import(/* webpackChunkName: "SleepPage" */ '../containers/SleepPage/SleepPage'));
const DoctorsPage = loadable(() => import(/* webpackChunkName: "DoctorsPage" */ '../containers/DoctorsPage/DoctorsPage'));
const OnboardingSuccessPage = loadable(() => import(/* webpackChunkName: "OnboardingSuccessPage" */ '../containers/OnboardingSuccessPage/OnboardingSuccessPage'));
const CompaniesPage = loadable(() => import(/* webpackChunkName: "CompaniesPage" */ '../containers/CompaniesPage/CompaniesPage'));
const GoogleAuthPage = loadable(() => import(/* webpackChunkName: "GoogleAuthPage" */ '../containers/GoogleAuthPage/GoogleAuthPage'));
const BlogPage = loadable(() => import(/* webpackChunkName: "BlogPage" */ '../containers/BlogPage/BlogPage'));
const FAQPage = loadable(() => import(/* webpackChunkName: "FAQPage" */ '../containers/FAQPage/FAQPage'));
const SingleBlogPage = loadable(() => import(/* webpackChunkName: "SingleBlogPage" */ '../containers/SingleBlogPage/SingleBlogPage'));
const AboutPage = loadable(() => import(/* webpackChunkName: "AboutPage" */ '../containers/AboutPage/AboutPage'));
const VideoGalleryPage = loadable(() => import(/* webpackChunkName: "VideoGalleryPage" */ '../containers/VideoGalleryPage/VideoGalleryPage'));
const FamilyProgramPage = loadable(() => import(/* webpackChunkName: "FamilyProgramPage" */ '../containers/FamilyProgramPage/FamilyProgramPage'));
const MyInvoicesPage = loadable(() => import(/* webpackChunkName: "MyInvoicesPage" */ '../containers/MyInvoicesPage/MyInvoicesPage'));
const MeetingPage = loadable(() => import(/* webpackChunkName: "MeetingPage" */ '../containers/MeetingPage/MeetingPage'));
const ContactPage = loadable(() => import(/* webpackChunkName: "ContactPage" */ '../containers/ContactPage/ContactPage'));
const ListingPageCoverPhoto = loadable(() => import(/* webpackChunkName: "ListingPageCoverPhoto" */ /* webpackPrefetch: true */ '../containers/ListingPage/ListingPageCoverPhoto'));
const ListingPageCarousel = loadable(() => import(/* webpackChunkName: "ListingPageCarousel" */ /* webpackPrefetch: true */ '../containers/ListingPage/ListingPageCarousel'));
const ManageListingsPage = loadable(() => import(/* webpackChunkName: "ManageListingsPage" */ '../containers/ManageListingsPage/ManageListingsPage'));
const PasswordChangePage = loadable(() => import(/* webpackChunkName: "PasswordChangePage" */ '../containers/PasswordChangePage/PasswordChangePage'));
const PasswordRecoveryPage = loadable(() => import(/* webpackChunkName: "PasswordRecoveryPage" */ '../containers/PasswordRecoveryPage/PasswordRecoveryPage'));
const PasswordResetPage = loadable(() => import(/* webpackChunkName: "PasswordResetPage" */ '../containers/PasswordResetPage/PasswordResetPage'));
const PaymentMethodsPage = loadable(() => import(/* webpackChunkName: "PaymentMethodsPage" */ '../containers/PaymentMethodsPage/PaymentMethodsPage'));
const LanguagePreferencesPage = loadable(() => import(/* webpackChunkName: "LanguagePreferencesPage" */ '../containers/LanguagePreferencesPage/LanguagePreferencesPage'));
const PrivacyPolicyPage = loadable(() => import(/* webpackChunkName: "PrivacyPolicyPage" */ '../containers/PrivacyPolicyPage/PrivacyPolicyPage'));
const ProfilePage = loadable(() => import(/* webpackChunkName: "ProfilePage" */ '../containers/ProfilePage/ProfilePage'));
const ProfileSettingsPage = loadable(() => import(/* webpackChunkName: "ProfileSettingsPage" */ '../containers/ProfileSettingsPage/ProfileSettingsPage'));
const MobileAIConsultPage = loadable(() => import(/* webpackChunkName: "MobileAIConsultPage" */ '../containers/AIConsultPage/MobileAIConsultPage.js'));
const DataPrivacyPage = loadable(() => import(/* webpackChunkName: "DataPrivacyPage" */ '../containers/DataPrivacyPage/DataPrivacyPage.js'));
const ProgramOnboardingPage = loadable(() => import(/* webpackChunkName: "ProfileSettingsPage" */ '../containers/ProgramOnboardingPage/ProgramOnboardingPage'));
const SearchPageWithMap = loadable(() => import(/* webpackChunkName: "SearchPageWithMap" */ /* webpackPrefetch: true */  '../containers/SearchPage/SearchPageWithMap'));
const SearchPageWithGrid = loadable(() => import(/* webpackChunkName: "SearchPageWithGrid" */ /* webpackPrefetch: true */  '../containers/SearchPage/SearchPageWithGrid'));
const StripePayoutPage = loadable(() => import(/* webpackChunkName: "StripePayoutPage" */ '../containers/StripePayoutPage/StripePayoutPage'));
const TermsOfServicePage = loadable(() => import(/* webpackChunkName: "TermsOfServicePage" */ '../containers/TermsOfServicePage/TermsOfServicePage'));
const TransactionPage = loadable(() => import(/* webpackChunkName: "TransactionPage" */ '../containers/TransactionPage/TransactionPage'));
const VouchersPage = loadable(() => import(/* webpackChunkName: "VouchersPage" */ '../containers/VouchersPage/VouchersPage'));
const TopicDetailsPage = loadable(() => import(/* webpackChunkName: "TopicDetailsPage" */ '../containers/TopicDetailsPage/TopicDetailsPage'));
const EventsPage = loadable(() => import(/* webpackChunkName: "EventsPage" */ '../containers/EventsPage/EventsPage'));
const EventDetailPage = loadable(() => import(/* webpackChunkName: "EventDetailPage" */ '../containers/EventDetailPage/EventDetailPage'));
const SubscriptionPage = loadable(() => import(/* webpackChunkName: "SubscriptionPage" */ '../containers/SubscriptionPage/SubscriptionPage'));
const MySubscriptionPage = loadable(() => import(/* webpackChunkName: "MySubscriptionPage" */ '../containers/MySubscriptionPage/MySubscriptionPage'));
const CoursesPage = loadable(() => import(/* webpackChunkName: "CoursesPage" */ '../containers/CoursesPage/CoursesPage'));
const GuidesPage = loadable(() => import(/* webpackChunkName: "GuidesPage" */ '../containers/GuidesPage/GuidesPage'));
const AIChatPage = loadable(() => import(/* webpackChunkName: "AIChatPage" */ '../containers/AIChatPage/AIChatPage'));
const SymptomPage = loadable(() => import(/* webpackChunkName: "SymptomPage" */ '../containers/SymptomPage/SymptomPage'));
const TheBasicsDetailsPage = loadable(() => import(/* webpackChunkName: "TheBasicsDetailsPage" */ '../containers/TheBasicsDetailsPage/TheBasicsDetailsPage'));
const VideoPlayerPage = loadable(() => import(/* webpackChunkName: "VideoPlayerPage" */ '../containers/VideoPlayerPage/VideoPlayerPage'));
const InvoicesPage = loadable(() => import(/* webpackChunkName: "InvoicesPage" */ '../containers/InvoicesPage/InvoicesPage'));
const CustomerOnboardingPage = loadable(() => import(/* webpackChunkName: "CustomerOnboardingPage" */ '../containers/CustomerOnboardingPage/CustomerOnboardingPage'));
const ProductTreatmentsPage = loadable(() => import(/* webpackChunkName: "ProductTreatmentsPage" */ '../containers/ProductsPage/ProductsPage'));
const SingleProductPage = loadable(() => import(/* webpackChunkName: "ProductTreatmentsPage" */ '../containers/SingleProductPage/SingleProductPage'));
const CustomWelcomePage = loadable(() => import(/* webpackChunkName: "ProfileSettingsPage" */ '../containers/CustomWelcomePage/CustomWelcomePage'));
const AIConsultPage = loadable(() => import(/* webpackChunkName: "MilvusPage" */ '../containers/AIConsultPage/AIConsultPage'));
const FavoritesPage = loadable(() => import(/* webpackChunkName: "FavoritesPage" */ '../containers/FavoritesPage/FavoritesPage'));
const WatchedVideosPage = loadable(() => import(/* webpackChunkName: "WatchedVideosPage" */ '../containers/WatchedVideosPage/WatchedVideosPage'));
const GuideDetailPage = loadable(() => import(/* webpackChunkName: "GuideDetailPage" */ '../containers/GuideDetailPage/GuideDetailPage'));
const SymptomDeailPage = loadable(() => import(/* webpackChunkName: "SymptomDeailPage" */ '../containers/SymptomDeailPage/SymptomDeailPage'));
const SymptomsTrackPage = loadable(() => import(/* webpackChunkName: "SymptomsTrackPage" */ '../containers/SymptomsTrackPage/SymptomsTrackPage'));
const MoodsTrackPage = loadable(() => import(/* webpackChunkName: "MoodsTrackPage" */ '../containers/MoodsTrackPage/MoodsTrackPage'));
const HabitsTrackPage = loadable(() => import(/* webpackChunkName: "HabitsTrackPage" */ '../containers/HabitsTrackPage/HabitsTrackPage'));
const TrackerDashboardPage = loadable(() => import(/* webpackChunkName: "TrackerDashboardPage" */ '../containers/TrackerDashboardPage/TrackerDashboardPage'));
const CustomLandingPage = loadable(() => import(/* webpackChunkName: "CustomLandingPage" */ '../containers/CustomLandingPage/CustomLandingPage'));
const PersonalSettingsPage = loadable(() => import(/* webpackChunkName: "PersonalSettingsPage" */ '../containers/PersonalSettingPage/PersonalSettingPage'));
const WellnessProgramPage = loadable(() => import(/* webpackChunkName: "WellnessProgramPage" */ '../containers/WellnessProgramPage/WellnessProgramPage'));
const WellnessProgramDetailsPage = loadable(() => import(/* webpackChunkName: "WellnessProgramDetailsPage" */ '../containers/WellnessProgramDetailsPage/WellnessProgramDetailsPage'));
const BioiatrikiLandingPage = loadable(() => import(/* webpackChunkName: "BioiatrikiLandingPage" */ '../containers/BioiatrikiLandingPage/BioiatrikiLandingPage'));
const PaywallPage = loadable(() => import(/* webpackChunkName: "PaywallPage" */ '../containers/PaywallPage/PaywallPage'));


// Styleguide helps you to review current components and develop new ones
const StyleguidePage = loadable(() => import(/* webpackChunkName: "StyleguidePage" */ '../containers/StyleguidePage/StyleguidePage'));

export const ACCOUNT_SETTINGS_PAGES = [

  'ContactDetailsPage',
  'PasswordChangePage',
  'StripePayoutPage',
  'PaymentMethodsPage',
  'LanguagePreferencesPage',
];

// https://en.wikipedia.org/wiki/Universally_unique_identifier#Nil_UUID
export const draftId = '00000000-0000-0000-0000-000000000000';
export const draftSlug = 'draft';

const RedirectToLandingPage = () => <NamedRedirect name="LandingPage" />;
const RedirectToLoginDrawerLanding = () => (
  <NamedRedirect name="LandingPage" search="?login=true" />
);

// put near RedirectToLandingPage
const RedirectToSingleBlog = () => {
  const { useParams } = require('react-router-dom');
  const { slug } = useParams();
  return <NamedRedirect name="SingleBlogPage" params={{ slug }} />;
};

const RedirectToRegister = () => <RedirectToLoginDrawerLanding />;



// NOTE: Most server-side endpoints are prefixed with /api. Requests to those
// endpoints are indended to be handled in the server instead of the browser and
// they will not render the application. So remember to avoid routes starting
// with /api and if you encounter clashing routes see server/index.js if there's
// a conflicting route defined there.

// Our routes are exact by default.
// See behaviour from Routes.js where Route is created.
const routeConfiguration = (layoutConfig) => {
  const SearchPage = layoutConfig?.searchPage?.variantType === 'map'
    ? SearchPageWithMap
    : SearchPageWithGrid;
  const ListingPage = layoutConfig?.listingPage?.variantType === 'carousel'
    ? ListingPageCarousel
    : ListingPageCoverPhoto;

  return [
    {
      path: '/',
      name: 'LandingPage',
      component: LandingPage,
    },
    {
      path: '/en/',
      name: 'LandingPage',
      component: LandingPage,
    },
    {
      path: '/bioiatriki',
      name: 'CustomLandingPage',
      component: CustomLandingPage,
    },
    {
      path: '/el/bioiatriki',
      name: 'CustomLandingPage',
      component: CustomLandingPage,
    },
    {
      path: '/en/bioiatriki',
      name: 'CustomLandingPage',
      component: CustomLandingPage,
    },
    {
      path: '/de/bioiatriki',
      path: '/ar/bioiatriki',
      name: 'CustomLandingPage',
      component: CustomLandingPage,
    },
    {
      path: '/el',
      name: 'LandingPage',
      component: LandingPage,
    },
    {
      path: '/de',
      name: 'LandingPage',
      component: LandingPage,
    },
    {
      path: '/ar',
      name: 'LandingPage',
      component: LandingPage,
    },
    {
      path: '/menopause',
      name: 'MenopausePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/el/menopause',
      name: 'LandingPage',
      component: RedirectToLandingPage,
    },
    {
      path: '/en/menopause',
      name: 'LandingPage',
      component: RedirectToLandingPage,
    },
    {
      path: '/de/menopause',
      name: 'LandingPage',
      component: RedirectToLandingPage,
    },
    {
      path: '/ar/menopause',
      name: 'LandingPage',
      component: RedirectToLandingPage,
    },
    {
      path: '/home/sexual-wellness',
      name: 'SexLandingPage',
      component: SexLandingPage,
    },
    {
      path: '/el/home/sexual-wellness',
      name: 'SexLandingPage',
      component: SexLandingPage,
    },
    {
      path: '/en/home/sexual-wellness',
      name: 'SexLandingPage',
      component: SexLandingPage,
    },
    {
      path: '/de/home/sexual-wellness',
      name: 'SexLandingPage',
      component: SexLandingPage,
    },
    {
      path: '/ar/home/sexual-wellness',
      name: 'SexLandingPage',
      component: SexLandingPage,
    },
    {
      path: '/sleep',
      name: 'SleepPage',
      component: SleepPage,
    },
    {
      path: '/en/sleep',
      name: 'SleepPage',
      component: SleepPage,
    },
    {
      path: '/el/sleep',
      name: 'SleepPage',
      component: SleepPage,
    },
    {
      path: '/de/sleep',
      name: 'SleepPage',
      component: SleepPage,
    },
    {
      path: '/ar/sleep',
      name: 'SleepPage',
      component: SleepPage,
    },
    {
      path: '/get-care',
      name: 'LandingPatientPage',
      component: LandingPatientPage,
    },
    {
      path: '/el/get-care',
      name: 'LandingPatientPage',
      component: LandingPatientPage,
    },
    {
      path: '/en/get-care',
      name: 'LandingPatientPage',
      component: LandingPatientPage,
    },
    {
      path: '/de/get-care',
      name: 'LandingPatientPage',
      component: LandingPatientPage,
    },
    {
      path: '/ar/get-care',
      name: 'LandingPatientPage',
      component: LandingPatientPage,
    },
    {
      path: '/test-videos',
      name: 'TestPage',
      component: TestPage,
    },
    {
      path: '/el/test-videos',
      name: 'TestPage',
      component: TestPage,
    },
    {
      path: '/en/test-videos',
      name: 'TestPage',
      component: TestPage,
    },
    {
      path: '/de/test-videos',
      name: 'TestPage',
      component: TestPage,
    },
    {
      path: '/ar/test-videos',
      name: 'TestPage',
      component: TestPage,
    },
    {
      path: '/paywall',
      name: 'PaywallPage',
      auth: true,
      component: PaywallPage,
    },
    {
      path: '/el/paywall',
      name: 'PaywallPage',
      auth: true,
      component: PaywallPage,
    },
    {
      path: '/en/paywall',
      name: 'PaywallPage',
      auth: true,
      component: PaywallPage,
    },
    {
      path: '/de/paywall',
      name: 'PaywallPage',
      auth: true,
      component: PaywallPage,
    },
    {
      path: '/ar/paywall',
      name: 'PaywallPage',
      auth: true,
      component: PaywallPage,
    },
    {
      path: '/search-content',
      name: 'SearchContentPage',
      auth: true,
      component: SearchContentPage,
    },
    {
      path: '/el/search-content',
      name: 'SearchContentPage',
      auth: true,
      component: SearchContentPage,
    },
    {
      path: '/en/search-content',
      name: 'SearchContentPage',
      auth: true,
      component: SearchContentPage,
    },
    {
      path: '/de/search-content',
      name: 'SearchContentPage',
      auth: true,
      component: SearchContentPage,
    },
    {
      path: '/ar/search-content',
      name: 'SearchContentPage',
      auth: true,
      component: SearchContentPage,
    },
    {
      path: '/resources',
      auth: true,
      name: 'MenopauseResourcePage',
      component: MenopauseResourcePage,
    },
    {
      path: '/el/resources',
      auth: true,
      name: 'MenopauseResourcePage',
      component: MenopauseResourcePage,
    },
    {
      path: '/en/resources',
      auth: true,
      name: 'MenopauseResourcePage',
      component: MenopauseResourcePage,
    },
    {
      path: '/de/resources',
      auth: true,
      name: 'MenopauseResourcePage',
      component: MenopauseResourcePage,
    },
    {
      path: '/ar/resources',
      auth: true,
      name: 'MenopauseResourcePage',
      component: MenopauseResourcePage,
    },
    {
      path: '/resources/:id',
      auth: true,
      name: 'GuideDetailPage',
      component: GuideDetailPage,
      requiresTrial: true,
    },
    {
      path: '/el/resources/:id',
      auth: true,
      name: 'GuideDetailPage',
      component: GuideDetailPage,
      requiresTrial: true,
    },
    {
      path: '/en/resources/:id',
      auth: true,
      name: 'GuideDetailPage',
      component: GuideDetailPage,
      requiresTrial: true,
    },
    {
      path: '/de/resources/:id',
      auth: true,
      name: 'GuideDetailPage',
      component: GuideDetailPage,
      requiresTrial: true,
    },
    {
      path: '/ar/resources/:id',
      auth: true,
      name: 'GuideDetailPage',
      component: GuideDetailPage,
      requiresTrial: true,
    },
    {
      path: '/home',
      auth: true,
      name: 'Homepage',
      component: Homepage,
    },
    {
      path: '/el/home',
      auth: true,
      name: 'Homepage',
      component: Homepage,
    },
    {
      path: '/en/home',
      auth: true,
      name: 'Homepage',
      component: Homepage,
    },
    {
      path: '/de/home',
      auth: true,
      name: 'Homepage',
      component: Homepage,
    },
    {
      path: '/ar/home',
      auth: true,
      name: 'Homepage',
      component: Homepage,
    },
    {
      path: '/favorites',
      auth: true,
      name: 'FavoritesPage',
      component: FavoritesPage,
      requiresTrial: true,
    },
    {
      path: '/el/favorites',
      auth: true,
      name: 'FavoritesPage',
      component: FavoritesPage,
      requiresTrial: true,
    },
    {
      path: '/en/favorites',
      auth: true,
      name: 'FavoritesPage',
      component: FavoritesPage,
      requiresTrial: true,
    },
    {
      path: '/de/favorites',
      auth: true,
      name: 'FavoritesPage',
      component: FavoritesPage,
      requiresTrial: true,
    },
    {
      path: '/ar/favorites',
      auth: true,
      name: 'FavoritesPage',
      component: FavoritesPage,
      requiresTrial: true,
    },
    {
      path: '/history',
      auth: true,
      name: 'WatchedVideosPage',
      component: WatchedVideosPage,
      requiresTrial: true,
    },
    {
      path: '/el/history',
      auth: true,
      name: 'WatchedVideosPage',
      component: WatchedVideosPage,
      requiresTrial: true,
    },
    {
      path: '/en/history',
      auth: true,
      name: 'WatchedVideosPage',
      component: WatchedVideosPage,
      requiresTrial: true,
    },
    {
      path: '/de/history',
      auth: true,
      name: 'WatchedVideosPage',
      component: WatchedVideosPage,
      requiresTrial: true,
    },
    {
      path: '/ar/history',
      auth: true,
      name: 'WatchedVideosPage',
      component: WatchedVideosPage,
      requiresTrial: true,
    },
    {
      path: '/questionnaire',
      name: 'QuestionsPage',
      component: QuestionsPage,
    },
    {
      path: '/el/questionnaire',
      name: 'QuestionsPage',
      component: QuestionsPage,
    },
    {
      path: '/en/questionnaire',
      name: 'QuestionsPage',
      component: QuestionsPage,
    },
    {
      path: '/de/questionnaire',
      name: 'QuestionsPage',
      component: QuestionsPage,
    },
    {
      path: '/ar/questionnaire',
      name: 'QuestionsPage',
      component: QuestionsPage,
    },
    {
      path: '/symptom/:symptom',
      auth: true,
      name: 'SymptomPage',
      component: SymptomPage,
      requiresTrial: true,
    },
    {
      path: '/el/symptom/:symptom',
      auth: true,
      name: 'SymptomPage',
      component: SymptomPage,
      requiresTrial: true,
    },
    {
      path: '/en/symptom/:symptom',
      auth: true,
      name: 'SymptomPage',
      component: SymptomPage,
      requiresTrial: true,
    },
    {
      path: '/de/symptom/:symptom',
      auth: true,
      name: 'SymptomPage',
      component: SymptomPage,
      requiresTrial: true,
    },
    {
      path: '/ar/symptom/:symptom',
      auth: true,
      name: 'SymptomPage',
      component: SymptomPage,
      requiresTrial: true,
    },
    {
      path: '/symptom/:symptom/:id',
      auth: true,
      name: 'SymptomDeailPage',
      component: SymptomDeailPage,
      requiresTrial: true,
    },
    {
      path: '/el/symptom/:symptom/:id',
      auth: true,
      name: 'SymptomDeailPage',
      component: SymptomDeailPage,
      requiresTrial: true,
    },
    {
      path: '/en/symptom/:symptom/:id',
      auth: true,
      name: 'SymptomDeailPage',
      component: SymptomDeailPage,
      requiresTrial: true,
    },
    {
      path: '/de/symptom/:symptom/:id',
      auth: true,
      name: 'SymptomDeailPage',
      component: SymptomDeailPage,
      requiresTrial: true,
    },
     {
      path: '/ar/symptom/:symptom/:id',
      auth: true,
      name: 'SymptomDeailPage',
      component: SymptomDeailPage,
      requiresTrial: true,
    },
    {
      path: '/the-basics/:slug',
      auth: true,
      name: 'TheBasicsDetailsPage',
      component: TheBasicsDetailsPage,
      requiresTrial: true,
    },
    {
      path: '/el/the-basics/:slug',
      auth: true,
      name: 'TheBasicsDetailsPage',
      component: TheBasicsDetailsPage,
      requiresTrial: true,
    },
    {
      path: '/en/the-basics/:slug',
      auth: true,
      name: 'TheBasicsDetailsPage',
      component: TheBasicsDetailsPage,
      requiresTrial: true,
    },
    {
      path: '/de/the-basics/:slug',
      auth: true,
      name: 'TheBasicsDetailsPage',
      component: TheBasicsDetailsPage,
      requiresTrial: true,
    },
    {
      path: '/ar/the-basics/:slug',
      auth: true,
      name: 'TheBasicsDetailsPage',
      component: TheBasicsDetailsPage,
      requiresTrial: true,
    },
    {
      path: '/videos/:slug',
      auth: true,
      name: 'VideoPlayerPage',
      component: VideoPlayerPage,
      requiresTrial: true,
    },
    {
      path: '/el/videos/:slug',
      auth: true,
      name: 'VideoPlayerPage',
      component: VideoPlayerPage,
      requiresTrial: true,
    },
    {
      path: '/en/videos/:slug',
      auth: true,
      name: 'VideoPlayerPage',
      component: VideoPlayerPage,
      requiresTrial: true,
    },
    {
      path: '/de/videos/:slug',
      auth: true,
      name: 'VideoPlayerPage',
      component: VideoPlayerPage,
      requiresTrial: true,
    },
     {
      path: '/ar/videos/:slug',
      auth: true,
      name: 'VideoPlayerPage',
      component: VideoPlayerPage,
      requiresTrial: true,
    },
    {
      path: '/invoice',
      auth: true,
      name: 'InvoicesPage',
      component: InvoicesPage,
    },
    {
      path: '/el/invoice',
      auth: true,
      name: 'InvoicesPage',
      component: InvoicesPage,
    },
    {
      path: '/en/invoice',
      auth: true,
      name: 'InvoicesPage',
      component: InvoicesPage,
    },
    {
      path: '/upcomming-events',
      name: 'UpcommingEventPage',
      component: UpcommingEventPage,
    },
    {
      path: '/el/upcomming-events',
      name: 'UpcommingEventPage',
      component: UpcommingEventPage,
    },
    {
      path: '/en/upcomming-events',
      name: 'UpcommingEventPage',
      component: UpcommingEventPage,
    },
    {
      path: '/de/upcomming-events',
      name: 'UpcommingEventPage',
      component: UpcommingEventPage,
    },
    {
      path: '/ar/upcomming-events',
      name: 'UpcommingEventPage',
      component: UpcommingEventPage,
    },
    {
      path: '/doctor/onboarding',
      auth: true,
      name: 'DoctorOnboardingPage',
      component: DoctorOnboardingPage,
    },
    {
      path: '/el/doctor/onboarding',
      auth: true,
      name: 'DoctorOnboardingPage',
      component: DoctorOnboardingPage,
    },
    {
      path: '/en/doctor/onboarding',
      auth: true,
      name: 'DoctorOnboardingPage',
      component: DoctorOnboardingPage,
    },
    {
      path: '/de/doctor/onboarding',
      auth: true,
      name: 'DoctorOnboardingPage',
      component: DoctorOnboardingPage,
    },
    {
      path: '/ar/doctor/onboarding',
      auth: true,
      name: 'DoctorOnboardingPage',
      component: DoctorOnboardingPage,
    },
    {
      path: '/doctor/onboarding/success',
      auth: true,
      name: 'OnboardingSuccessPage',
      component: OnboardingSuccessPage,
    },
    {
      path: '/el/doctor/onboarding/success',
      auth: true,
      name: 'OnboardingSuccessPage',
      component: OnboardingSuccessPage,
    },
    {
      path: '/en/doctor/onboarding/success',
      auth: true,
      name: 'OnboardingSuccessPage',
      component: OnboardingSuccessPage,
    },
    {
      path: '/de/doctor/onboarding/success',
      auth: true,
      name: 'OnboardingSuccessPage',
      component: OnboardingSuccessPage,
    },
    {
      path: '/ar/doctor/onboarding/success',
      auth: true,
      name: 'OnboardingSuccessPage',
      component: OnboardingSuccessPage,
    },
    {
      path: '/doctors',
      name: 'DoctorsPage',
      component: DoctorsPage,
    },
    {
      path: '/el/doctors',
      name: 'DoctorsPage',
      component: DoctorsPage,
    },
    {
      path: '/en/doctors',
      name: 'DoctorsPage',
      component: DoctorsPage,
    },
    {
      path: '/de/doctors',
      name: 'DoctorsPage',
      component: DoctorsPage,
    },
     {
      path: '/ar/doctors',
      name: 'DoctorsPage',
      component: DoctorsPage,
    },
    {
      path: '/rea',
      name: 'DoctorsPage',
      component: DoctorsPage,
    },
    {
      path: '/el/rea',
      name: 'DoctorsPage',
      component: DoctorsPage,
    },
    {
      path: '/en/rea',
      name: 'DoctorsPage',
      component: DoctorsPage,
    },
    {
      path: '/de/rea',
      name: 'DoctorsPage',
      component: DoctorsPage,
    },
    {
      path: '/ar/rea',
      name: 'DoctorsPage',
      component: DoctorsPage,
    },
    {
      path: '/dashboard',
      name: 'DashboardPage',
      auth: true,
      component: DashboardPage,
      loadData: pageDataLoadingAPI.DashboardPage.loadData,
    },
    {
      path: '/el/dashboard',
      name: 'DashboardPage',
      auth: true,
      component: DashboardPage,
      loadData: pageDataLoadingAPI.DashboardPage.loadData,
    },
    {
      path: '/en/dashboard',
      name: 'DashboardPage',
      auth: true,
      component: DashboardPage,
      loadData: pageDataLoadingAPI.DashboardPage.loadData,
    },
    {
      path: '/de/dashboard',
      name: 'DashboardPage',
      auth: true,
      component: DashboardPage,
      loadData: pageDataLoadingAPI.DashboardPage.loadData,
    },
    {
      path: '/ar/dashboard',
      name: 'DashboardPage',
      auth: true,
      component: DashboardPage,
      loadData: pageDataLoadingAPI.DashboardPage.loadData,
    },
    {
      path: '/vouchers',
      name: 'VouchersPage',
      auth: true,
      component: VouchersPage,
      loadData: pageDataLoadingAPI.VouchersPage.loadData,
    },
    {
      path: '/el/vouchers',
      name: 'VouchersPage',
      auth: true,
      component: VouchersPage,
      loadData: pageDataLoadingAPI.VouchersPage.loadData,
    },
    {
      path: '/en/vouchers',
      name: 'VouchersPage',
      auth: true,
      component: VouchersPage,
      loadData: pageDataLoadingAPI.VouchersPage.loadData,
    },
    {
      path: '/de/vouchers',
      name: 'VouchersPage',
      auth: true,
      component: VouchersPage,
      loadData: pageDataLoadingAPI.VouchersPage.loadData,
    },
    {
      path: '/ar/vouchers',
      name: 'VouchersPage',
      auth: true,
      component: VouchersPage,
      loadData: pageDataLoadingAPI.VouchersPage.loadData,
    },
    {
      path: '/doctors-payments',
      name: 'DoctorsPaymentPage',
      auth: true,
      component: DoctorsPaymentPage,
      loadData: pageDataLoadingAPI.DoctorsPaymentPage.loadData,
    },
    {
      path: '/el/doctors-payments',
      name: 'DoctorsPaymentPage',
      auth: true,
      component: DoctorsPaymentPage,
      loadData: pageDataLoadingAPI.DoctorsPaymentPage.loadData,
    },
    {
      path: '/en/doctors-payments',
      name: 'DoctorsPaymentPage',
      auth: true,
      component: DoctorsPaymentPage,
      loadData: pageDataLoadingAPI.DoctorsPaymentPage.loadData,
    },
    {
      path: '/ar/doctors-payments',
      name: 'DoctorsPaymentPage',
      auth: true,
      component: DoctorsPaymentPage,
      loadData: pageDataLoadingAPI.DoctorsPaymentPage.loadData,
    },{
      path: '/de/doctors-payments',
      name: 'DoctorsPaymentPage',
      auth: true,
      component: DoctorsPaymentPage,
      loadData: pageDataLoadingAPI.DoctorsPaymentPage.loadData,
    },
    {
      path: '/companies',
      name: 'CompaniesPage',
      component: CompaniesPage,
    },
    {
      path: '/el/companies',
      name: 'CompaniesPage',
      component: CompaniesPage,
    },
    {
      path: '/en/companies',
      name: 'CompaniesPage',
      component: CompaniesPage,
    },
    {
      path: '/ar/companies',
      name: 'CompaniesPage',
      component: CompaniesPage,
    },
    {
      path: '/de/companies',
      name: 'CompaniesPage',
      component: CompaniesPage,
    },
    {
      path: '/blogs',
      name: 'BlogPage',
      component: BlogPage,
      loadData: pageDataLoadingAPI.BlogPage.loadData,
    },
    {
      path: '/el/blogs',
      name: 'BlogPage',
      component: BlogPage,
      loadData: pageDataLoadingAPI.BlogPage.loadData,
    },
    {
      path: '/en/blogs',
      name: 'BlogPage',
      component: BlogPage,
      loadData: pageDataLoadingAPI.BlogPage.loadData,
    },
    {
      path: '/ar/blogs',
      name: 'BlogPage',
      component: BlogPage,
      loadData: pageDataLoadingAPI.BlogPage.loadData,
    },
    {
      path: '/de/blogs',
      name: 'BlogPage',
      component: BlogPage,
      loadData: pageDataLoadingAPI.BlogPage.loadData,
    },
    {
      path: '/faq',
      name: 'FAQPage',
      component: FAQPage,
    },
    {
      path: '/el/faq',
      name: 'FAQPage',
      component: FAQPage,
    },
    {
      path: '/en/faq',
      name: 'FAQPage',
      component: FAQPage,
    },
    {
      path: '/de/faq',
      name: 'FAQPage',
      component: FAQPage,
    },
    {
      path: '/ar/faq',
      name: 'FAQPage',
      component: FAQPage,
    },
    {
      path: '/google-auth',
      name: 'GoogleAuthPage',
      component: GoogleAuthPage,
      loadData: pageDataLoadingAPI.GoogleAuthPage.loadData,
    },
    {
      path: '/el/google-auth',
      name: 'GoogleAuthPage',
      component: GoogleAuthPage,
      loadData: pageDataLoadingAPI.GoogleAuthPage.loadData,
    },
    {
      path: '/en/google-auth',
      name: 'GoogleAuthPage',
      component: GoogleAuthPage,
      loadData: pageDataLoadingAPI.GoogleAuthPage.loadData,
    },
    {
      path: '/de/google-auth',
      name: 'GoogleAuthPage',
      component: GoogleAuthPage,
      loadData: pageDataLoadingAPI.GoogleAuthPage.loadData,
    },
    {
      path: '/ar/google-auth',
      name: 'GoogleAuthPage',
      component: GoogleAuthPage,
      loadData: pageDataLoadingAPI.GoogleAuthPage.loadData,
    },
    {
      path: '/blog/:slug',
      name: 'SingleBlogPage',
      component: SingleBlogPage,
      loadData: pageDataLoadingAPI.SingleBlogPage.loadData,
    },
    {
      path: '/el/blog/:slug',
      name: 'SingleBlogPage',
      component: SingleBlogPage,
      loadData: pageDataLoadingAPI.SingleBlogPage.loadData,
    },
    {
      path: '/en/blog/:slug',
      name: 'SingleBlogPage',
      component: SingleBlogPage,
      loadData: pageDataLoadingAPI.SingleBlogPage.loadData,
    },
    {
      path: '/de/blog/:slug',
      name: 'SingleBlogPage',
      component: SingleBlogPage,
      loadData: pageDataLoadingAPI.SingleBlogPage.loadData,
    },
    {
      path: '/ar/blog/:slug',
      name: 'SingleBlogPage',
      component: SingleBlogPage,
      loadData: pageDataLoadingAPI.SingleBlogPage.loadData,
    },
    // Legacy blog URLs with :id → redirect to slug-only
    {
      path: '/blog/:id/:slug',
      name: 'SingleBlogLegacyRedirect',
      component: RedirectToSingleBlog,
    },
    {
      path: '/el/blog/:id/:slug',
      name: 'SingleBlogLegacyRedirectEL',
      component: RedirectToSingleBlog,
    },
    {
      path: '/en/blog/:id/:slug',
      name: 'SingleBlogLegacyRedirectEN',
      component: RedirectToSingleBlog,
    },
    {
      path: '/de/blog/:id/:slug',
      name: 'SingleBlogLegacyRedirectDE',
      component: RedirectToSingleBlog,
    },
    {
      path: '/ar/blog/:id/:slug',
      name: 'SingleBlogLegacyRedirectAR',
      component: RedirectToSingleBlog,
    },
    {
      path: '/about',
      name: 'AboutPage',
      component: AboutPage,
    },
    {
      path: '/el/about',
      name: 'AboutPage',
      component: AboutPage,
    },
    {
      path: '/en/about',
      name: 'AboutPage',
      component: AboutPage,
    },
    {
      path: '/de/about',
      name: 'AboutPage',
      component: AboutPage,
    },
    {
      path: '/ar/about',
      name: 'AboutPage',
      component: AboutPage,
    },
    {
      path: '/gallery',
      name: 'VideoGalleryPage',
      component: VideoGalleryPage,
    },
    {
      path: '/el/gallery',
      name: 'VideoGalleryPage',
      component: VideoGalleryPage,
    },
    {
      path: '/en/gallery',
      name: 'VideoGalleryPage',
      component: VideoGalleryPage,
    },
    {
      path: '/de/gallery',
      name: 'VideoGalleryPage',
      component: VideoGalleryPage,
    },
     {
      path: '/ar/gallery',
      name: 'VideoGalleryPage',
      component: VideoGalleryPage,
    },
    {
      path: '/meeting/:id',
      name: 'MeetingPage',
      auth: true,
      component: MeetingPage,
      loadData: pageDataLoadingAPI.MeetingPage.loadData,
    },
    {
      path: '/el/meeting/:id',
      name: 'MeetingPage',
      auth: true,
      component: MeetingPage,
      loadData: pageDataLoadingAPI.MeetingPage.loadData,
    },
    {
      path: '/en/meeting/:id',
      name: 'MeetingPage',
      auth: true,
      component: MeetingPage,
      loadData: pageDataLoadingAPI.MeetingPage.loadData,
    },
    {
      path: '/de/meeting/:id',
      name: 'MeetingPage',
      auth: true,
      component: MeetingPage,
      loadData: pageDataLoadingAPI.MeetingPage.loadData,
    },
    {
      path: '/ar/meeting/:id',
      name: 'MeetingPage',
      auth: true,
      component: MeetingPage,
      loadData: pageDataLoadingAPI.MeetingPage.loadData,
    },
    {
      path: '/contact',
      name: 'ContactPage',
      component: ContactPage,
    },
    {
      path: '/el/contact',
      name: 'ContactPage',
      component: ContactPage,
    },
    {
      path: '/en/contact',
      name: 'ContactPage',
      component: ContactPage,
    },
    {
      path: '/de/contact',
      name: 'ContactPage',
      component: ContactPage,
    },
    {
      path: '/ar/contact',
      name: 'ContactPage',
      component: ContactPage,
    },
    {
      path: '/search',
      name: 'SearchPage',
      component: SearchPage,
      loadData: pageDataLoadingAPI.SearchPage.loadData,
    },
    {
      path: '/el/search',
      name: 'SearchPage',
      component: SearchPage,
      loadData: pageDataLoadingAPI.SearchPage.loadData,
    },
    {
      path: '/en/search',
      name: 'SearchPage',
      component: SearchPage,
      loadData: pageDataLoadingAPI.SearchPage.loadData,
    },
    {
      path: '/de/search',
      name: 'SearchPage',
      component: SearchPage,
      loadData: pageDataLoadingAPI.SearchPage.loadData,
    },
    {
      path: '/ar/search',
      name: 'SearchPage',
      component: SearchPage,
      loadData: pageDataLoadingAPI.SearchPage.loadData,
    },
    {
      path: '/products',
      name: 'ProductTreatmentsPage',
      component: ProductTreatmentsPage,
    },
    {
      path: '/el/products',
      name: 'ProductTreatmentsPage',
      component: ProductTreatmentsPage,
    },
    {
      path: '/en/products',
      name: 'ProductTreatmentsPage',
      component: ProductTreatmentsPage,
    },
    {
      path: '/de/products',
      name: 'ProductTreatmentsPage',
      component: ProductTreatmentsPage,
    },
    {
      path: '/ar/products',
      name: 'ProductTreatmentsPage',
      component: ProductTreatmentsPage,
    },
    {
      path: '/products/:slug',
      name: 'SingleProductPage',
      component: SingleProductPage,
      requiresTrial: true,
    },
    {
      path: '/el/products/:slug',
      name: 'SingleProductPage',
      component: SingleProductPage,
      requiresTrial: true,
    },
    {
      path: '/en/products/:slug',
      name: 'SingleProductPage',
      component: SingleProductPage,
      requiresTrial: true,
    },
    {
      path: '/de/products/:slug',
      name: 'SingleProductPage',
      component: SingleProductPage,
      requiresTrial: true,
    },
     {
      path: '/ar/products/:slug',
      name: 'SingleProductPage',
      component: SingleProductPage,
      requiresTrial: true,
    },
    {
      path: '/l',
      name: 'ListingBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/el/l',
      name: 'ListingBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/en/l',
      name: 'ListingBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/de/l',
      name: 'ListingBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/ar/l',
      name: 'ListingBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/l/:slug/:id',
      name: 'ListingPage',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/el/l/:slug/:id',
      name: 'ListingPage',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/en/l/:slug/:id',
      name: 'ListingPage',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/de/l/:slug/:id',
      name: 'ListingPage',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
     {
      path: '/ar/l/:slug/:id',
      name: 'ListingPage',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/l/:slug/:id/checkout',
      name: 'CheckoutPage',
      auth: true,
      component: CheckoutPage,
      setInitialValues: pageDataLoadingAPI.CheckoutPage.setInitialValues,
    },
    {
      path: '/el/l/:slug/:id/checkout',
      name: 'CheckoutPage',
      auth: true,
      component: CheckoutPage,
      setInitialValues: pageDataLoadingAPI.CheckoutPage.setInitialValues,
    },
    {
      path: '/en/l/:slug/:id/checkout',
      name: 'CheckoutPage',
      auth: true,
      component: CheckoutPage,
      setInitialValues: pageDataLoadingAPI.CheckoutPage.setInitialValues,
    },
    {
      path: '/de/l/:slug/:id/checkout',
      name: 'CheckoutPage',
      auth: true,
      component: CheckoutPage,
      setInitialValues: pageDataLoadingAPI.CheckoutPage.setInitialValues,
    },
    {
      path: '/ar/l/:slug/:id/checkout',
      name: 'CheckoutPage',
      auth: true,
      component: CheckoutPage,
      setInitialValues: pageDataLoadingAPI.CheckoutPage.setInitialValues,
    },
    {
      path: '/l/:slug/:id/:variant',
      name: 'ListingPageVariant',
      auth: true,
      authPage: 'LoginPage',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/el/l/:slug/:id/:variant',
      name: 'ListingPageVariant',
      auth: true,
      authPage: 'LoginPage',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/en/l/:slug/:id/:variant',
      name: 'ListingPageVariant',
      auth: true,
      authPage: 'LoginPage',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/de/l/:slug/:id/:variant',
      name: 'ListingPageVariant',
      auth: true,
      authPage: 'LoginPage',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
     {
      path: '/ar/l/:slug/:id/:variant',
      name: 'ListingPageVariant',
      auth: true,
      authPage: 'LoginPage',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/l/new',
      name: 'NewListingPage',
      auth: true,
      component: () => (
        <NamedRedirect
          name="EditListingPage"
          params={{ slug: draftSlug, id: draftId, type: 'new', tab: 'details' }}
        />
      ),
    },
    {
      path: '/el/l/new',
      name: 'NewListingPage',
      auth: true,
      component: () => (
        <NamedRedirect
          name="EditListingPage"
          params={{ slug: draftSlug, id: draftId, type: 'new', tab: 'details' }}
        />
      ),
    },
    {
      path: '/en/l/new',
      name: 'NewListingPage',
      auth: true,
      component: () => (
        <NamedRedirect
          name="EditListingPage"
          params={{ slug: draftSlug, id: draftId, type: 'new', tab: 'details' }}
        />
      ),
    },
    {
      path: '/de/l/new',
      name: 'NewListingPage',
      auth: true,
      component: () => (
        <NamedRedirect
          name="EditListingPage"
          params={{ slug: draftSlug, id: draftId, type: 'new', tab: 'details' }}
        />
      ),
    },
    {
      path: '/ar/l/new',
      name: 'NewListingPage',
      auth: true,
      component: () => (
        <NamedRedirect
          name="EditListingPage"
          params={{ slug: draftSlug, id: draftId, type: 'new', tab: 'details' }}
        />
      ),
    },
    {
      path: '/l/:slug/:id/:type/:tab',
      name: 'EditListingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },
    {
      path: '/el/l/:slug/:id/:type/:tab',
      name: 'EditListingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },
    {
      path: '/en/l/:slug/:id/:type/:tab',
      name: 'EditListingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },
    {
      path: '/de/l/:slug/:id/:type/:tab',
      name: 'EditListingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },
    {
      path: '/ar/l/:slug/:id/:type/:tab',
      name: 'EditListingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },
    {
      path: '/l/:slug/:id/:type/:tab/:returnURLType',
      name: 'EditListingStripeOnboardingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },
    {
      path: '/el/l/:slug/:id/:type/:tab/:returnURLType',
      name: 'EditListingStripeOnboardingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },
    {
      path: '/en/l/:slug/:id/:type/:tab/:returnURLType',
      name: 'EditListingStripeOnboardingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },
    {
      path: '/de/l/:slug/:id/:type/:tab/:returnURLType',
      name: 'EditListingStripeOnboardingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },
     {
      path: '/ar/l/:slug/:id/:type/:tab/:returnURLType',
      name: 'EditListingStripeOnboardingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },
    {
      path: '/l/:id',
      name: 'ListingPageCanonical',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/el/l/:id',
      name: 'ListingPageCanonical',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/en/l/:id',
      name: 'ListingPageCanonical',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/de/l/:id',
      name: 'ListingPageCanonical',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/ar/l/:id',
      name: 'ListingPageCanonical',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/u',
      name: 'ProfileBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/el/u',
      name: 'ProfileBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/en/u',
      name: 'ProfileBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/de/u',
      name: 'ProfileBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/ar/u',
      name: 'ProfileBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/u/:id',
      name: 'ProfilePage',
      component: ProfilePage,
      loadData: pageDataLoadingAPI.ProfilePage.loadData,
    },
    {
      path: '/el/u/:id',
      name: 'ProfilePage',
      component: ProfilePage,
      loadData: pageDataLoadingAPI.ProfilePage.loadData,
    },
    {
      path: '/en/u/:id',
      name: 'ProfilePage',
      component: ProfilePage,
      loadData: pageDataLoadingAPI.ProfilePage.loadData,
    },
    {
      path: '/de/u/:id',
      name: 'ProfilePage',
      component: ProfilePage,
      loadData: pageDataLoadingAPI.ProfilePage.loadData,
    },
     {
      path: '/ar/u/:id',
      name: 'ProfilePage',
      component: ProfilePage,
      loadData: pageDataLoadingAPI.ProfilePage.loadData,
    },
    {
      path: '/profile-settings',
      name: 'ProfileSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ProfileSettingsPage,
    },
    {
      path: '/el/profile-settings',
      name: 'ProfileSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ProfileSettingsPage,
    },
    {
      path: '/en/profile-settings',
      name: 'ProfileSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ProfileSettingsPage,
    },
    {
      path: '/de/profile-settings',
      name: 'ProfileSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ProfileSettingsPage,
    },
    {
      path: '/ar/profile-settings',
      name: 'ProfileSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ProfileSettingsPage,
    },
    {
      path: '/auth/mobile',
      name: 'MobileAuthPage',
      component: MobileAuthPage,
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: AuthenticationPage,
      extraProps: { tab: 'login' },
    },
    {
      path: '/el/login',
      name: 'LoginPage',
      component: AuthenticationPage,
      extraProps: { tab: 'login' },
    },
    {
      path: '/en/login',
      name: 'LoginPage',
      component: AuthenticationPage,
      extraProps: { tab: 'login' },
    },
    {
      path: '/de/login',
      name: 'LoginPage',
      component: AuthenticationPage,
      extraProps: { tab: 'login' },
    },
    {
      path: '/ar/login',
      name: 'LoginPage',
      component: AuthenticationPage,
      extraProps: { tab: 'login' },
    },
    {
      path: '/signup',
      name: 'SignupPage',
      component: RedirectToLoginDrawerLanding,
    },
    {
      path: '/el/signup',
      name: 'SignupPage',
      component: RedirectToLoginDrawerLanding,
    },
    {
      path: '/en/signup',
      name: 'SignupPage',
      component: RedirectToLoginDrawerLanding,
    },
    {
      path: '/de/signup',
      name: 'SignupPage',
      component: RedirectToLoginDrawerLanding,
    },
    {
      path: '/ar/signup',
      name: 'SignupPage',
      component: RedirectToLoginDrawerLanding,
    },
    {
      path: '/signup/:type',
      name: 'AuthenticationPageSelector',
      component: RedirectToLoginDrawerLanding,
    },
    {
      path: '/el/signup/:type',
      name: 'AuthenticationPageSelector',
      component: RedirectToLoginDrawerLanding,
    },
    {
      path: '/en/signup/:type',
      name: 'AuthenticationPageSelector',
      component: RedirectToLoginDrawerLanding,
    },
    {
      path: '/de/signup/:type',
      name: 'AuthenticationPageSelector',
      component: RedirectToLoginDrawerLanding,
    },
    {
      path: '/ar/signup/:type',
      name: 'AuthenticationPageSelector',
      component: RedirectToLoginDrawerLanding,
    },
    {
      path: '/confirm',
      name: 'ConfirmPage',
      component: AuthenticationPage,
      extraProps: { tab: 'confirm' },
    },
    {
      path: '/el/confirm',
      name: 'ConfirmPage',
      component: AuthenticationPage,
      extraProps: { tab: 'confirm' },
    },
    {
      path: '/en/confirm',
      name: 'ConfirmPage',
      component: AuthenticationPage,
      extraProps: { tab: 'confirm' },
    },
    {
      path: '/de/confirm',
      name: 'ConfirmPage',
      component: AuthenticationPage,
      extraProps: { tab: 'confirm' },
    },
     {
      path: '/ar/confirm',
      name: 'ConfirmPage',
      component: AuthenticationPage,
      extraProps: { tab: 'confirm' },
    },
    {
      path: '/recover-password',
      name: 'PasswordRecoveryPage',
      component: PasswordRecoveryPage,
    },
    {
      path: '/el/recover-password',
      name: 'PasswordRecoveryPage',
      component: PasswordRecoveryPage,
    },
    {
      path: '/en/recover-password',
      name: 'PasswordRecoveryPage',
      component: PasswordRecoveryPage,
    },
    {
      path: '/de/recover-password',
      name: 'PasswordRecoveryPage',
      component: PasswordRecoveryPage,
    },
    {
      path: '/ar/recover-password',
      name: 'PasswordRecoveryPage',
      component: PasswordRecoveryPage,
    },
     {
      path: '/delete-account',
      name: 'DeleteAccountPage',
      component: DeleteAccountPage,
    },
    {
      path: '/el/delete-account',
      name: 'DeleteAccountPage',
      component: DeleteAccountPage,
    },
    {
      path: '/en/delete-account',
      name: 'DeleteAccountPage',
      component: DeleteAccountPage,
    },
    {
      path: '/de/delete-account',
      name: 'DeleteAccountPage',
      component: DeleteAccountPage,
    },
    {
      path: '/inbox',
      name: 'InboxBasePage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="InboxPage" params={{ tab: 'sales' }} />,
    },
    {
      path: '/el/inbox',
      name: 'InboxBasePage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="InboxPage" params={{ tab: 'sales' }} />,
    },
    {
      path: '/en/inbox',
      name: 'InboxBasePage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="InboxPage" params={{ tab: 'sales' }} />,
    },
    {
      path: '/de/inbox',
      name: 'InboxBasePage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="InboxPage" params={{ tab: 'sales' }} />,
    },
     {
      path: '/ar/inbox',
      name: 'InboxBasePage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="InboxPage" params={{ tab: 'sales' }} />,
    },
    {
      path: '/inbox/:tab',
      name: 'InboxPage',
      auth: true,
      authPage: 'LoginPage',
      component: InboxPage,
      loadData: pageDataLoadingAPI.InboxPage.loadData,
    },
    {
      path: '/el/inbox/:tab',
      name: 'InboxPage',
      auth: true,
      authPage: 'LoginPage',
      component: InboxPage,
      loadData: pageDataLoadingAPI.InboxPage.loadData,
    },
    {
      path: '/en/inbox/:tab',
      name: 'InboxPage',
      auth: true,
      authPage: 'LoginPage',
      component: InboxPage,
      loadData: pageDataLoadingAPI.InboxPage.loadData,
    },
    {
      path: '/de/inbox/:tab',
      name: 'InboxPage',
      auth: true,
      authPage: 'LoginPage',
      component: InboxPage,
      loadData: pageDataLoadingAPI.InboxPage.loadData,
    },
     {
      path: '/ar/inbox/:tab',
      name: 'InboxPage',
      auth: true,
      authPage: 'LoginPage',
      component: InboxPage,
      loadData: pageDataLoadingAPI.InboxPage.loadData,
    },
    {
      path: '/order/:id',
      name: 'OrderDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'customer' },
      loadData: (params, ...rest) =>
        pageDataLoadingAPI.TransactionPage.loadData({ ...params, transactionRole: 'customer' }, ...rest),
      setInitialValues: pageDataLoadingAPI.TransactionPage.setInitialValues,
    },
    {
      path: '/el/order/:id',
      name: 'OrderDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'customer' },
      loadData: (params, ...rest) =>
        pageDataLoadingAPI.TransactionPage.loadData({ ...params, transactionRole: 'customer' }, ...rest),
      setInitialValues: pageDataLoadingAPI.TransactionPage.setInitialValues,
    },
    {
      path: '/en/order/:id',
      name: 'OrderDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'customer' },
      loadData: (params, ...rest) =>
        pageDataLoadingAPI.TransactionPage.loadData({ ...params, transactionRole: 'customer' }, ...rest),
      setInitialValues: pageDataLoadingAPI.TransactionPage.setInitialValues,
    },
    {
      path: '/de/order/:id',
      name: 'OrderDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'customer' },
      loadData: (params, ...rest) =>
        pageDataLoadingAPI.TransactionPage.loadData({ ...params, transactionRole: 'customer' }, ...rest),
      setInitialValues: pageDataLoadingAPI.TransactionPage.setInitialValues,
    },
     {
      path: '/ar/order/:id',
      name: 'OrderDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'customer' },
      loadData: (params, ...rest) =>
        pageDataLoadingAPI.TransactionPage.loadData({ ...params, transactionRole: 'customer' }, ...rest),
      setInitialValues: pageDataLoadingAPI.TransactionPage.setInitialValues,
    },
    {
      path: '/sale/:id',
      name: 'SaleDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'provider' },
      loadData: pageDataLoadingAPI.TransactionPage.loadData,
    },
    {
      path: '/el/sale/:id',
      name: 'SaleDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'provider' },
      loadData: pageDataLoadingAPI.TransactionPage.loadData,
    },
    {
      path: '/en/sale/:id',
      name: 'SaleDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'provider' },
      loadData: pageDataLoadingAPI.TransactionPage.loadData,
    },
    {
      path: '/de/sale/:id',
      name: 'SaleDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'provider' },
      loadData: pageDataLoadingAPI.TransactionPage.loadData,
    },
     {
      path: '/ar/sale/:id',
      name: 'SaleDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'provider' },
      loadData: pageDataLoadingAPI.TransactionPage.loadData,
    },
    {
      path: '/sale/:id/chat',
      name: 'SaleChatPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'provider' },
      loadData: pageDataLoadingAPI.TransactionPage.loadData,
    },
    {
      path: '/el/sale/:id/chat',
      name: 'SaleChatPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'provider' },
      loadData: pageDataLoadingAPI.TransactionPage.loadData,
    },
    {
      path: '/en/sale/:id/chat',
      name: 'SaleChatPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'provider' },
      loadData: pageDataLoadingAPI.TransactionPage.loadData,
    },
    {
      path: '/de/sale/:id/chat',
      name: 'SaleChatPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'provider' },
      loadData: pageDataLoadingAPI.TransactionPage.loadData,
    },
     {
      path: '/ar/sale/:id/chat',
      name: 'SaleChatPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'provider' },
      loadData: pageDataLoadingAPI.TransactionPage.loadData,
    },
    {
      path: '/order/:id/chat',
      name: 'OrderChatPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'customer' },
      loadData: (params, ...rest) =>
        pageDataLoadingAPI.TransactionPage.loadData({ ...params, transactionRole: 'customer' }, ...rest),
      setInitialValues: pageDataLoadingAPI.TransactionPage.setInitialValues,
    },
    {
      path: '/el/order/:id/chat',
      name: 'OrderChatPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'customer' },
      loadData: (params, ...rest) =>
        pageDataLoadingAPI.TransactionPage.loadData({ ...params, transactionRole: 'customer' }, ...rest),
      setInitialValues: pageDataLoadingAPI.TransactionPage.setInitialValues,
    },
    {
      path: '/en/order/:id/chat',
      name: 'OrderChatPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'customer' },
      loadData: (params, ...rest) =>
        pageDataLoadingAPI.TransactionPage.loadData({ ...params, transactionRole: 'customer' }, ...rest),
      setInitialValues: pageDataLoadingAPI.TransactionPage.setInitialValues,
    },
    {
      path: '/de/order/:id/chat',
      name: 'OrderChatPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'customer' },
      loadData: (params, ...rest) =>
        pageDataLoadingAPI.TransactionPage.loadData({ ...params, transactionRole: 'customer' }, ...rest),
      setInitialValues: pageDataLoadingAPI.TransactionPage.setInitialValues,
    },
    {
      path: '/ar/order/:id/chat',
      name: 'OrderChatPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'customer' },
      loadData: (params, ...rest) =>
        pageDataLoadingAPI.TransactionPage.loadData({ ...params, transactionRole: 'customer' }, ...rest),
      setInitialValues: pageDataLoadingAPI.TransactionPage.setInitialValues,
    },
    {
      path: '/listings',
      name: 'ManageListingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ManageListingsPage,
      loadData: pageDataLoadingAPI.ManageListingsPage.loadData,
    },
    {
      path: '/el/listings',
      name: 'ManageListingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ManageListingsPage,
      loadData: pageDataLoadingAPI.ManageListingsPage.loadData,
    },
    {
      path: '/en/listings',
      name: 'ManageListingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ManageListingsPage,
      loadData: pageDataLoadingAPI.ManageListingsPage.loadData,
    },
    {
      path: '/de/listings',
      name: 'ManageListingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ManageListingsPage,
      loadData: pageDataLoadingAPI.ManageListingsPage.loadData,
    },
     {
      path: '/ar/listings',
      name: 'ManageListingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ManageListingsPage,
      loadData: pageDataLoadingAPI.ManageListingsPage.loadData,
    },
    {
      path: '/account',
      name: 'AccountSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="ContactDetailsPage" />,
    },
    {
      path: '/el/account',
      name: 'AccountSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="ContactDetailsPage" />,
    },
    {
      path: '/en/account',
      name: 'AccountSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="ContactDetailsPage" />,
    },
    {
      path: '/de/account',
      name: 'AccountSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="ContactDetailsPage" />,
    },
    {
      path: '/ar/account',
      name: 'AccountSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="ContactDetailsPage" />,
    },
    {
      path: '/account/contact-details',
      name: 'ContactDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ContactDetailsPage,
      loadData: pageDataLoadingAPI.ContactDetailsPage.loadData,
    },
    {
      path: '/el/account/contact-details',
      name: 'ContactDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ContactDetailsPage,
      loadData: pageDataLoadingAPI.ContactDetailsPage.loadData,
    },
    {
      path: '/en/account/contact-details',
      name: 'ContactDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ContactDetailsPage,
      loadData: pageDataLoadingAPI.ContactDetailsPage.loadData,
    },
    {
      path: '/de/account/contact-details',
      name: 'ContactDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ContactDetailsPage,
      loadData: pageDataLoadingAPI.ContactDetailsPage.loadData,
    },
     {
      path: '/ar/account/contact-details',
      name: 'ContactDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ContactDetailsPage,
      loadData: pageDataLoadingAPI.ContactDetailsPage.loadData,
    },
    {
      path: '/account/change-password',
      name: 'PasswordChangePage',
      auth: true,
      authPage: 'LoginPage',
      component: PasswordChangePage,
    },
    {
      path: '/el/account/change-password',
      name: 'PasswordChangePage',
      auth: true,
      authPage: 'LoginPage',
      component: PasswordChangePage,
    },
    {
      path: '/en/account/change-password',
      name: 'PasswordChangePage',
      auth: true,
      authPage: 'LoginPage',
      component: PasswordChangePage,
    },
    {
      path: '/de/account/change-password',
      name: 'PasswordChangePage',
      auth: true,
      authPage: 'LoginPage',
      component: PasswordChangePage,
    },
    {
      path: '/ar/account/change-password',
      name: 'PasswordChangePage',
      auth: true,
      authPage: 'LoginPage',
      component: PasswordChangePage,
    },
    {
      path: '/account/payments',
      name: 'StripePayoutPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/el/account/payments',
      name: 'StripePayoutPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/en/account/payments',
      name: 'StripePayoutPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/de/account/payments',
      name: 'StripePayoutPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
     {
      path: '/ar/account/payments',
      name: 'StripePayoutPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/account/payments/:returnURLType',
      name: 'StripePayoutOnboardingPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/el/account/payments/:returnURLType',
      name: 'StripePayoutOnboardingPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/en/account/payments/:returnURLType',
      name: 'StripePayoutOnboardingPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/de/account/payments/:returnURLType',
      name: 'StripePayoutOnboardingPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
      {
      path: '/ar/account/payments/:returnURLType',
      name: 'StripePayoutOnboardingPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/account/payment-methods',
      name: 'PaymentMethodsPage',
      auth: true,
      authPage: 'LoginPage',
      component: PaymentMethodsPage,
      loadData: pageDataLoadingAPI.PaymentMethodsPage.loadData,
    },
    {
      path: '/el/account/payment-methods',
      name: 'PaymentMethodsPage',
      auth: true,
      authPage: 'LoginPage',
      component: PaymentMethodsPage,
      loadData: pageDataLoadingAPI.PaymentMethodsPage.loadData,
    },
    {
      path: '/en/account/payment-methods',
      name: 'PaymentMethodsPage',
      auth: true,
      authPage: 'LoginPage',
      component: PaymentMethodsPage,
      loadData: pageDataLoadingAPI.PaymentMethodsPage.loadData,
    },
    {
      path: '/de/account/payment-methods',
      name: 'PaymentMethodsPage',
      auth: true,
      authPage: 'LoginPage',
      component: PaymentMethodsPage,
      loadData: pageDataLoadingAPI.PaymentMethodsPage.loadData,
    },
     {
      path: '/ar/account/payment-methods',
      name: 'PaymentMethodsPage',
      auth: true,
      authPage: 'LoginPage',
      component: PaymentMethodsPage,
      loadData: pageDataLoadingAPI.PaymentMethodsPage.loadData,
    },
    {
      path: '/account/language-preferences',
      name: 'LanguagePreferencesPage',
      auth: true,
      authPage: 'LoginPage',
      component: LanguagePreferencesPage,
    },
    {
      path: '/el/account/language-preferences',
      name: 'LanguagePreferencesPage',
      auth: true,
      authPage: 'LoginPage',
      component: LanguagePreferencesPage,
    },
    {
      path: '/en/account/language-preferences',
      name: 'LanguagePreferencesPage',
      auth: true,
      authPage: 'LoginPage',
      component: LanguagePreferencesPage,
    },
    {
      path: '/de/account/language-preferences',
      name: 'LanguagePreferencesPage',
      auth: true,
      authPage: 'LoginPage',
      component: LanguagePreferencesPage,
    },
     {
      path: '/ar/account/language-preferences',
      name: 'LanguagePreferencesPage',
      auth: true,
      authPage: 'LoginPage',
      component: LanguagePreferencesPage,
    },
    {
      path: '/terms-of-service',
      name: 'TermsOfServicePage',
      component: TermsOfServicePage,
      loadData: pageDataLoadingAPI.TermsOfServicePage.loadData,
    },
    {
      path: '/el/terms-of-service',
      name: 'TermsOfServicePage',
      component: TermsOfServicePage,
      loadData: pageDataLoadingAPI.TermsOfServicePage.loadData,
    },
    {
      path: '/en/terms-of-service',
      name: 'TermsOfServicePage',
      component: TermsOfServicePage,
      loadData: pageDataLoadingAPI.TermsOfServicePage.loadData,
    },
    {
      path: '/de/terms-of-service',
      name: 'TermsOfServicePage',
      component: TermsOfServicePage,
      loadData: pageDataLoadingAPI.TermsOfServicePage.loadData,
    },
    {
      path: '/ar/terms-of-service',
      name: 'TermsOfServicePage',
      component: TermsOfServicePage,
      loadData: pageDataLoadingAPI.TermsOfServicePage.loadData,
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicyPage',
      component: PrivacyPolicyPage,
      loadData: pageDataLoadingAPI.PrivacyPolicyPage.loadData,
    },
    {
      path: '/el/privacy-policy',
      name: 'PrivacyPolicyPage',
      component: PrivacyPolicyPage,
      loadData: pageDataLoadingAPI.PrivacyPolicyPage.loadData,
    },
    {
      path: '/en/privacy-policy',
      name: 'PrivacyPolicyPage',
      component: PrivacyPolicyPage,
      loadData: pageDataLoadingAPI.PrivacyPolicyPage.loadData,
    },
    {
      path: '/de/privacy-policy',
      name: 'PrivacyPolicyPage',
      component: PrivacyPolicyPage,
      loadData: pageDataLoadingAPI.PrivacyPolicyPage.loadData,
    },
     {
      path: '/ar/privacy-policy',
      name: 'PrivacyPolicyPage',
      component: PrivacyPolicyPage,
      loadData: pageDataLoadingAPI.PrivacyPolicyPage.loadData,
    },
    {
      path: '/impressum',
      name: 'Impressum',
      component: ImpressumPage,
    },
    {
      path: '/de/impressum',
      name: 'Impressum',
      component: ImpressumPage,
    },
    {
      path: '/ar/impressum',
      name: 'Impressum',
      component: ImpressumPage,
    },
    {
      path: '/cookie-policy',
      name: 'CookiePolicy',
      component: CookiePolicy,
      loadData: pageDataLoadingAPI.PrivacyPolicyPage.loadData,
    },
    {
      path: '/el/cookie-policy',
      name: 'CookiePolicy',
      component: CookiePolicy,
      loadData: pageDataLoadingAPI.PrivacyPolicyPage.loadData,
    },
    {
      path: '/en/cookie-policy',
      name: 'CookiePolicy',
      component: CookiePolicy,
      loadData: pageDataLoadingAPI.PrivacyPolicyPage.loadData,
    },
    {
      path: '/de/cookie-policy',
      name: 'CookiePolicy',
      component: CookiePolicy,
      loadData: pageDataLoadingAPI.PrivacyPolicyPage.loadData,
    },
    {
      path: '/ar/cookie-policy',
      name: 'CookiePolicy',
      component: CookiePolicy,
      loadData: pageDataLoadingAPI.PrivacyPolicyPage.loadData,
    },
    {
      path: '/styleguide',
      name: 'Styleguide',
      component: StyleguidePage,
    },
    {
      path: '/el/styleguide',
      name: 'Styleguide',
      component: StyleguidePage,
    },
    {
      path: '/en/styleguide',
      name: 'Styleguide',
      component: StyleguidePage,
    },
    {
      path: '/de/styleguide',
      name: 'Styleguide',
      component: StyleguidePage,
    },
    {
      path: '/ar/styleguide',
      name: 'Styleguide',
      component: StyleguidePage,
    },
    {
      path: '/styleguide/g/:group',
      name: 'StyleguideGroup',
      component: StyleguidePage,
    },
    {
      path: '/el/styleguide/g/:group',
      name: 'StyleguideGroup',
      component: StyleguidePage,
    },
    {
      path: '/en/styleguide/g/:group',
      name: 'StyleguideGroup',
      component: StyleguidePage,
    },
    {
      path: '/de/styleguide/g/:group',
      name: 'StyleguideGroup',
      component: StyleguidePage,
    },
     {
      path: '/ar/styleguide/g/:group',
      name: 'StyleguideGroup',
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component',
      name: 'StyleguideComponent',
      component: StyleguidePage,
    },
    {
      path: '/el/styleguide/c/:component',
      name: 'StyleguideComponent',
      component: StyleguidePage,
    },
    {
      path: '/en/styleguide/c/:component',
      name: 'StyleguideComponent',
      component: StyleguidePage,
    },
    {
      path: '/de/styleguide/c/:component',
      name: 'StyleguideComponent',
      component: StyleguidePage,
    },
    {
      path: '/ar/styleguide/c/:component',
      name: 'StyleguideComponent',
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component/:example',
      name: 'StyleguideComponentExample',
      component: StyleguidePage,
    },
    {
      path: '/el/styleguide/c/:component/:example',
      name: 'StyleguideComponentExample',
      component: StyleguidePage,
    },
    {
      path: '/en/styleguide/c/:component/:example',
      name: 'StyleguideComponentExample',
      component: StyleguidePage,
    },
    {
      path: '/de/styleguide/c/:component/:example',
      name: 'StyleguideComponentExample',
      component: StyleguidePage,
    },
    {
      path: '/ar/styleguide/c/:component/:example',
      name: 'StyleguideComponentExample',
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component/:example/raw',
      name: 'StyleguideComponentExampleRaw',
      component: StyleguidePage,
      extraProps: { raw: true },
    },
    {
      path: '/el/styleguide/c/:component/:example/raw',
      name: 'StyleguideComponentExampleRaw',
      component: StyleguidePage,
      extraProps: { raw: true },
    },
    {
      path: '/en/styleguide/c/:component/:example/raw',
      name: 'StyleguideComponentExampleRaw',
      component: StyleguidePage,
      extraProps: { raw: true },
    },
    {
      path: '/de/styleguide/c/:component/:example/raw',
      name: 'StyleguideComponentExampleRaw',
      component: StyleguidePage,
      extraProps: { raw: true },
    },
    {
      path: '/ar/styleguide/c/:component/:example/raw',
      name: 'StyleguideComponentExampleRaw',
      component: StyleguidePage,
      extraProps: { raw: true },
    },
    {
      path: '/notfound',
      name: 'NotFoundPage',
      component: props => <NotFoundPage {...props} />,
    },
    {
      path: '/el/notfound',
      name: 'NotFoundPage',
      component: props => <NotFoundPage {...props} />,
    },
    {
      path: '/en/notfound',
      name: 'NotFoundPage',
      component: props => <NotFoundPage {...props} />,
    },
    {
      path: '/de/notfound',
      name: 'NotFoundPage',
      component: props => <NotFoundPage {...props} />,
    },
    {
      path: '/ar/notfound',
      name: 'NotFoundPage',
      component: props => <NotFoundPage {...props} />,
    },
    {
      path: '/reset-password',
      name: 'PasswordResetPage',
      component: PasswordResetPage,
    },
    {
      path: '/el/reset-password',
      name: 'PasswordResetPage',
      component: PasswordResetPage,
    },
    {
      path: '/en/reset-password',
      name: 'PasswordResetPage',
      component: PasswordResetPage,
    },
    {
      path: '/de/reset-password',
      name: 'PasswordResetPage',
      component: PasswordResetPage,
    },
    {
      path: '/ar/reset-password',
      name: 'PasswordResetPage',
      component: PasswordResetPage,
    },
    {
      path: '/verify-email',
      name: 'EmailVerificationPage',
      auth: true,
      authPage: 'LoginPage',
      component: EmailVerificationPage,
      loadData: pageDataLoadingAPI.EmailVerificationPage.loadData,
    },
    {
      path: '/el/verify-email',
      name: 'EmailVerificationPage',
      auth: true,
      authPage: 'LoginPage',
      component: EmailVerificationPage,
      loadData: pageDataLoadingAPI.EmailVerificationPage.loadData,
    },
    {
      path: '/en/verify-email',
      name: 'EmailVerificationPage',
      auth: true,
      authPage: 'LoginPage',
      component: EmailVerificationPage,
      loadData: pageDataLoadingAPI.EmailVerificationPage.loadData,
    },
    {
      path: '/de/verify-email',
      name: 'EmailVerificationPage',
      auth: true,
      authPage: 'LoginPage',
      component: EmailVerificationPage,
      loadData: pageDataLoadingAPI.EmailVerificationPage.loadData,
    },
    {
      path: '/ar/verify-email',
      name: 'EmailVerificationPage',
      auth: true,
      authPage: 'LoginPage',
      component: EmailVerificationPage,
      loadData: pageDataLoadingAPI.EmailVerificationPage.loadData,
    },
    {
      path: '/preview',
      name: 'PreviewResolverPage',
      component: PreviewResolverPage,
    },
    {
      path: '/el/preview',
      name: 'PreviewResolverPage',
      component: PreviewResolverPage,
    },
    {
      path: '/en/preview',
      name: 'PreviewResolverPage',
      component: PreviewResolverPage,
    },
    {
      path: '/de/preview',
      name: 'PreviewResolverPage',
      component: PreviewResolverPage,
    },
    {
      path: '/ar/preview',
      name: 'PreviewResolverPage',
      component: PreviewResolverPage,
    },
    {
      path: '/written-guide/:slug/:id',
      auth: true,
      name: 'GuideDetailPage',
      component: GuideDetailPage,
      requiresTrial: true,
    },
    {
      path: '/el/written-guide/:slug/:id',
      auth: true,
      name: 'GuideDetailPage',
      component: GuideDetailPage,
      requiresTrial: true,
    },
    {
      path: '/en/written-guide/:slug/:id',
      auth: true,
      name: 'GuideDetailPage',
      component: GuideDetailPage,
      requiresTrial: true,
    },
    {
      path: '/de/written-guide/:slug/:id',
      auth: true,
      name: 'GuideDetailPage',
      component: GuideDetailPage,
      requiresTrial: true,
    },
    {
      path: '/ar/written-guide/:slug/:id',
      auth: true,
      name: 'GuideDetailPage',
      component: GuideDetailPage,
      requiresTrial: true,
    },
    {
      path: '/written-guide/:slug/:guide',
      auth: true,
      name: 'TopicDetailsPage',
      component: TopicDetailsPage,
      requiresTrial: true,
    },
    {
      path: '/el/written-guide/:slug/:guide',
      auth: true,
      name: 'TopicDetailsPage',
      component: TopicDetailsPage,
      requiresTrial: true,
    },
    {
      path: '/en/written-guide/:slug/:guide',
      auth: true,
      name: 'TopicDetailsPage',
      component: TopicDetailsPage,
      requiresTrial: true,
    },
    {
      path: '/de/written-guide/:slug/:guide',
      auth: true,
      name: 'TopicDetailsPage',
      component: TopicDetailsPage,
      requiresTrial: true,
    },
    {
      path: '/ar/written-guide/:slug/:guide',
      auth: true,
      name: 'TopicDetailsPage',
      component: TopicDetailsPage,
      requiresTrial: true,
    },
    {
      path: '/written-guide/:slug',
      name: 'WrittenGuidesPage',
      auth: true,
      component: TopicDetailsPage,
      requiresTrial: true,
    },
    {
      path: '/el/written-guide/:slug',
      name: 'WrittenGuidesPage',
      auth: true,
      component: TopicDetailsPage,
      requiresTrial: true,
    },
    {
      path: '/en/written-guide/:slug',
      name: 'WrittenGuidesPage',
      auth: true,
      component: TopicDetailsPage,
      requiresTrial: true,
    },
    {
      path: '/de/written-guide/:slug',
      name: 'WrittenGuidesPage',
      auth: true,
      component: TopicDetailsPage,
      requiresTrial: true,
    },
    {
      path: '/ar/written-guide/:slug',
      name: 'WrittenGuidesPage',
      auth: true,
      component: TopicDetailsPage,
      requiresTrial: true,
    },
    {
      path: '/events',
      name: 'EventsPage',
      auth: true,
      component: EventsPage,
    },
    {
      path: '/el/events',
      name: 'EventsPage',
      auth: true,
      component: EventsPage,
    },
    {
      path: '/en/events',
      name: 'EventsPage',
      auth: true,
      component: EventsPage,
    },
    {
      path: '/de/events',
      name: 'EventsPage',
      auth: true,
      component: EventsPage,
    },
    {
      path: '/ar/events',
      name: 'EventsPage',
      auth: true,
      component: EventsPage,
    },
    {
      path: '/event/:title',
      name: 'EventDetailPage',
      auth: true,
      component: EventDetailPage,
    },
    {
      path: '/el/event/:title',
      name: 'EventDetailPage',
      auth: true,
      component: EventDetailPage,
    },
    {
      path: '/en/event/:title',
      name: 'EventDetailPage',
      auth: true,
      component: EventDetailPage,
    },
    {
      path: '/de/event/:title',
      name: 'EventDetailPage',
      auth: true,
      component: EventDetailPage,
    },
    {
      path: '/ar/event/:title',
      name: 'EventDetailPage',
      auth: true,
      component: EventDetailPage,
    },
    {
      path: '/subscription',
      name: 'SubscriptionPage',
      auth: true,
      component: MySubscriptionPage,
      loadData: pageDataLoadingAPI.MySubscriptionPage.loadData,
    },
    {
      path: '/el/subscription',
      name: 'SubscriptionPage',
      auth: true,
      component: MySubscriptionPage,
      loadData: pageDataLoadingAPI.MySubscriptionPage.loadData,
    },
    {
      path: '/en/subscription',
      name: 'SubscriptionPage',
      auth: true,
      component: MySubscriptionPage,
      loadData: pageDataLoadingAPI.MySubscriptionPage.loadData,
    },
    {
      path: '/de/subscription',
      name: 'SubscriptionPage',
      auth: true,
      component: MySubscriptionPage,
      loadData: pageDataLoadingAPI.MySubscriptionPage.loadData,
    },
    {
      path: '/ar/subscription',
      name: 'SubscriptionPage',
      auth: true,
      component: MySubscriptionPage,
      loadData: pageDataLoadingAPI.MySubscriptionPage.loadData,
    },
    {
      path: '/program-onboarding',
      name: 'ProgramOnboardingLegacyRedirect',
      component: RedirectToRegister,
    },
    {
      path: '/el/program-onboarding',
      name: 'ProgramOnboardingLegacyRedirectEL',
      component: RedirectToRegister,
    },
    {
      path: '/en/program-onboarding',
      name: 'ProgramOnboardingLegacyRedirectEN',
      component: RedirectToRegister,
    },
    {
      path: '/de/program-onboarding',
      name: 'ProgramOnboardingLegacyRedirectAR',
      component: RedirectToRegister,
    },
    {
      path: '/ar/program-onboarding',
      name: 'ProgramOnboardingLegacyRedirectAR',
      component: RedirectToRegister,
    },
    {
      path: '/register',
      name: 'ProgramOnboardingPage',
      component: ProgramOnboardingPage,
      extraProps: { forceCorporateCoupon: true },
    },
    {
      path: '/el/register',
      name: 'ProgramOnboardingPage',
      component: ProgramOnboardingPage,
      extraProps: { forceCorporateCoupon: true },
    },
    {
      path: '/en/register',
      name: 'ProgramOnboardingPage',
      component: ProgramOnboardingPage,
      extraProps: { forceCorporateCoupon: true },
    },
    {
      path: '/de/register',
      name: 'ProgramOnboardingPage',
      component: ProgramOnboardingPage,
      extraProps: { forceCorporateCoupon: true },
    },
    {
      path: '/ar/register',
      name: 'ProgramOnboardingPage',
      component: ProgramOnboardingPage,
      extraProps: { forceCorporateCoupon: true },
    },
    {
      path: '/welcome',
      name: 'CustomWelcomePage',
      component: CustomWelcomePage,
    },
    {
      path: '/el/welcome',
      name: 'CustomWelcomePage',
      component: CustomWelcomePage,
    },
    {
      path: '/en/welcome',
      name: 'CustomWelcomePage',
      component: CustomWelcomePage,
    },
    {
      path: '/de/welcome',
      name: 'CustomWelcomePage',
      component: CustomWelcomePage,
    },
    {
      path: '/ar/welcome',
      name: 'CustomWelcomePage',
      component: CustomWelcomePage,
    },
    {
      path: '/onboarding',
      name: 'OnboardingFlowPage',
      component: RedirectToLoginDrawerLanding,
    },
    {
      path: '/el/onboarding',
      name: 'OnboardingFlowPage',
      component: RedirectToLoginDrawerLanding,
    },
    {
      path: '/en/onboarding',
      name: 'OnboardingFlowPage',
      component: RedirectToLoginDrawerLanding,
    },
    {
      path: '/de/onboarding',
      name: 'OnboardingFlowPage',
      component: RedirectToLoginDrawerLanding,
    },
    {
      path: '/ar/onboarding',
      name: 'OnboardingFlowPage',
      component: RedirectToLoginDrawerLanding,
    },
    {
      path: '/onboarding/coupon',
      name: 'OnboardingCouponFlowPage',
      component: RedirectToLoginDrawerLanding,
    },
    {
      path: '/el/onboarding/coupon',
      name: 'OnboardingCouponFlowPage',
      component: RedirectToLoginDrawerLanding,
    },
    {
      path: '/en/onboarding/coupon',
      name: 'OnboardingCouponFlowPage',
      component: RedirectToLoginDrawerLanding,
    },
    {
      path: '/de/onboarding/coupon',
      name: 'OnboardingCouponFlowPage',
      component: RedirectToLoginDrawerLanding,
    },
    {
      path: '/ar/onboarding/coupon',
      name: 'OnboardingCouponFlowPage',
      component: RedirectToLoginDrawerLanding,
    },
    {
      path: '/courses',
      name: 'CoursesPage',
      component: CoursesPage,
    },
    {
      path: '/el/courses',
      name: 'CoursesPage',
      component: CoursesPage,
    },
    {
      path: '/en/courses',
      name: 'CoursesPage',
      component: CoursesPage,
    },
    {
      path: '/de/courses',
      name: 'CoursesPage',
      component: CoursesPage,
    },
    {
      path: '/ar/courses',
      name: 'CoursesPage',
      component: CoursesPage,
    },
    {
      path: '/family-program',
      name: 'FamilyProgramPage',
      auth: true,
      component: FamilyProgramPage,
    },
    {
      path: '/el/family-program',
      name: 'FamilyProgramPage',
      auth: true,
      component: FamilyProgramPage,
    },
    {
      path: '/en/family-program',
      name: 'FamilyProgramPage',
      auth: true,
      component: FamilyProgramPage,
    },
    {
      path: '/de/family-program',
      name: 'FamilyProgramPage',
      auth: true,
      component: FamilyProgramPage,
    },
    {
      path: '/ar/family-program',
      name: 'FamilyProgramPage',
      auth: true,
      component: FamilyProgramPage,
    },
    {
      path: '/guides/:module',
      name: 'GuidesBasePage',
      auth: true,
      component: GuidesPage,
      requiresTrial: true,
    },
    {
      path: '/el/guides/:module',
      name: 'GuidesBasePage',
      auth: true,
      component: GuidesPage,
      requiresTrial: true,
    },
    {
      path: '/en/guides/:module',
      name: 'GuidesBasePage',
      auth: true,
      component: GuidesPage,
      requiresTrial: true,
    },
    {
      path: '/de/guides/:module',
      name: 'GuidesBasePage',
      auth: true,
      component: GuidesPage,
      requiresTrial: true,
    },
    {
      path: '/ar/guides/:module',
      name: 'GuidesBasePage',
      auth: true,
      component: GuidesPage,
      requiresTrial: true,
    },
    {
      path: '/guides/:module/:slug',
      name: 'GuidesPage',
      auth: true,
      component: GuidesPage,
      requiresTrial: true,
    },
    {
      path: '/el/guides/:module/:slug',
      name: 'GuidesPage',
      auth: true,
      component: GuidesPage,
      requiresTrial: true,
    },
    {
      path: '/en/guides/:module/:slug',
      name: 'GuidesPage',
      auth: true,
      component: GuidesPage,
      requiresTrial: true,
    },
    {
      path: '/de/guides/:module/:slug',
      name: 'GuidesPage',
      auth: true,
      component: GuidesPage,
      requiresTrial: true,
    },
    {
      path: '/ar/guides/:module/:slug',
      name: 'GuidesPage',
      auth: true,
      component: GuidesPage,
      requiresTrial: true,
    },
    {
      path: '/ai-chat',
      name: 'AIChatPage',
      component: AIChatPage,
      loadData: pageDataLoadingAPI.AIChatPage.loadData,
    },
    {
      path: '/el/ai-chat',
      name: 'AIChatPage',
      component: AIChatPage,
      loadData: pageDataLoadingAPI.AIChatPage.loadData,
    },
    {
      path: '/unsubscribe',
      name: 'UnsubscribePage',
      component: UnsubscribePage,
    },
    {
      path: '/en/ai-chat',
      name: 'AIChatPage',
      component: AIChatPage,
      loadData: pageDataLoadingAPI.AIChatPage.loadData,
    },
    {
      path: '/de/ai-chat',
      name: 'AIChatPage',
      component: AIChatPage,
      loadData: pageDataLoadingAPI.AIChatPage.loadData,
    },
    {
      path: '/ar/ai-chat',
      name: 'AIChatPage',
      component: AIChatPage,
      loadData: pageDataLoadingAPI.AIChatPage.loadData,
    },
    {
      path: '/chat/:id',
      name: 'NewAIChatPage',
      component: AIChatPage,
      loadData: pageDataLoadingAPI.AIChatPage.loadData,
    },
    {
      path: '/el/chat/:id',
      name: 'NewAIChatPage',
      component: AIChatPage,
      loadData: pageDataLoadingAPI.AIChatPage.loadData,
    },
    {
      path: '/en/chat/:id',
      name: 'NewAIChatPage',
      component: AIChatPage,
      loadData: pageDataLoadingAPI.AIChatPage.loadData,
    },
    {
      path: '/de/chat/:id',
      name: 'NewAIChatPage',
      component: AIChatPage,
      loadData: pageDataLoadingAPI.AIChatPage.loadData,
    },
    {
      path: '/ar/chat/:id',
      name: 'NewAIChatPage',
      component: AIChatPage,
      loadData: pageDataLoadingAPI.AIChatPage.loadData,
    },
    {
      path: '/my-invoices',
      auth: true,
      name: 'MyInvoicesPage',
      component: MyInvoicesPage,
    },
    {
      path: '/el/my-invoices',
      auth: true,
      name: 'MyInvoicesPage',
      component: MyInvoicesPage,
    },
    {
      path: '/en/my-invoices',
      auth: true,
      name: 'MyInvoicesPage',
      component: MyInvoicesPage,
    },
    {
      path: '/de/my-invoices',
      auth: true,
      name: 'MyInvoicesPage',
      component: MyInvoicesPage,
    },
    {
      path: '/ar/my-invoices',
      auth: true,
      name: 'MyInvoicesPage',
      component: MyInvoicesPage,
    },
    {
      path: '/customer-onboarding',
      name: 'CustomerOnboardingPage',
      component: ProgramOnboardingPage,
    },
    {
      path: '/el/customer-onboarding',
      name: 'CustomerOnboardingPage',
      component: ProgramOnboardingPage,
    },
    {
      path: '/en/customer-onboarding',
      name: 'CustomerOnboardingPage',
      component: ProgramOnboardingPage,
    },
    {
      path: '/de/customer-onboarding',
      name: 'CustomerOnboardingPage',
      component: ProgramOnboardingPage,
    },
    {
      path: '/ar/customer-onboarding',
      name: 'CustomerOnboardingPage',
      component: ProgramOnboardingPage,
    },
    {
      path: '/health-plans',
      name: 'HealthPlansPage',
      component: HealthPlansPage,
    },
    {
      path: '/el/health-plans',
      name: 'HealthPlansPage',
      component: HealthPlansPage,
    },
    {
      path: '/en/health-plans',
      name: 'HealthPlansPage',
      component: HealthPlansPage,
    },
    {
      path: '/de/health-plans',
      name: 'HealthPlansPage',
      component: HealthPlansPage,
    },
    {
      path: '/ar/health-plans',
      name: 'HealthPlansPage',
      component: HealthPlansPage,
    },
    {
      path: '/ai-coach',
      name: 'AiPage',
      component: AiPage,
      requiresTrial: true,
    },
    {
      path: '/el/ai-coach',
      name: 'AiPage',
      component: AiPage,
      requiresTrial: true,
    },
    {
      path: '/en/ai-coach',
      name: 'AiPage',
      component: AiPage,
      requiresTrial: true,
    },
    {
      path: '/de/ai-coach',
      name: 'AiPage',
      component: AiPage,
      requiresTrial: true,
    },
    {
      path: '/ar/ai-coach',
      name: 'AiPage',
      component: AiPage,
      requiresTrial: true,
    },
    {
      path: '/employers',
      name: 'EmployersPage',
      component: EmployersPage,
    },
    {
      path: '/el/employers',
      name: 'EmployersPage',
      component: EmployersPage,
    },
    {
      path: '/en/employers',
      name: 'EmployersPage',
      component: EmployersPage,
    },
    {
      path: '/de/employers',
      name: 'EmployersPage',
      component: EmployersPage,
    },
    {
      path: '/ar/employers',
      name: 'EmployersPage',
      component: EmployersPage,
    },
    {
      path: '/hospitals-and-clinics',
      name: 'HospitalsAndClinicsPage',
      component: HospitalsAndClinicsPage,
    },
    {
      path: '/el/hospitals-and-clinics',
      name: 'HospitalsAndClinicsPage',
      component: HospitalsAndClinicsPage,
    },
    {
      path: '/en/hospitals-and-clinics',
      name: 'HospitalsAndClinicsPage',
      component: HospitalsAndClinicsPage,
    },
    {
      path: '/de/hospitals-and-clinics',
      name: 'HospitalsAndClinicsPage',
      component: HospitalsAndClinicsPage,
    },
    {
      path: '/ar/hospitals-and-clinics',
      name: 'HospitalsAndClinicsPage',
      component: HospitalsAndClinicsPage,
    },
    {
      path: '/family-program',
      name: 'FemaleHealthProgramPage',
      auth: true,
      component: FemaleHealthProgramPage,
    },
    {
      path: '/el/family-program',
      name: 'FemaleHealthProgramPage',
      auth: true,
      component: FemaleHealthProgramPage,
    },
    {
      path: '/en/family-program',
      name: 'FemaleHealthProgramPage',
      auth: true,
      component: FemaleHealthProgramPage,
    },
    {
      path: '/de/family-program',
      name: 'FemaleHealthProgramPage',
      auth: true,
      component: FemaleHealthProgramPage,
    },
    {
      path: '/ar/family-program',
      name: 'FemaleHealthProgramPage',
      auth: true,
      component: FemaleHealthProgramPage,
    },
    {
      path: '/ai',
      name: 'AIConsultPage',
      component: AIConsultPage,
      requiresTrial: true,
    },
    //This path is used for react native, dont remove it
    {
      path: '/mobile-ai',
      name: 'MobileAIConsultPage',
      component: MobileAIConsultPage,
    },
    {
      path: '/data-processing-addendum',
      name: 'DataPrivacyPage',
      component: DataPrivacyPage,
    },
    {
      path: '/el/data-processing-addendum',
      name: 'DataPrivacyPage',
      component: DataPrivacyPage,
    },
    {
      path: '/en/data-processing-addendum',
      name: 'DataPrivacyPage',
      component: DataPrivacyPage,
    },
    {
      path: '/de/data-processing-addendum',
      name: 'DataPrivacyPage',
      component: DataPrivacyPage,
    },
    {
      path: '/ar/data-processing-addendum',
      name: 'DataPrivacyPage',
      component: DataPrivacyPage,
    },
    {
      path: '/el/ai',
      name: 'AIConsultPage',

      component: AIConsultPage,
    },
    {
      path: '/en/ai',
      name: 'AIConsultPage',

      component: AIConsultPage,
    },
    {
      path: '/de/ai',
      name: 'AIConsultPage',

      component: AIConsultPage,
    },
    {
      path: '/ar/ai',
      name: 'AIConsultPage',

      component: AIConsultPage,
    },
    {
      path: '/the-basics/:slug/:id',
      auth: true,
      name: 'GuideDetailPage',
      component: GuideDetailPage,
      requiresTrial: true,
    },
    {
      path: '/el/the-basics/:slug/:id',
      auth: true,
      name: 'GuideDetailPage',
      component: GuideDetailPage,
      requiresTrial: true,
    },
    {
      path: '/en/the-basics/:slug/:id',
      auth: true,
      name: 'GuideDetailPage',
      component: GuideDetailPage,
      requiresTrial: true,
    },
    {
      path: '/de/the-basics/:slug/:id',
      auth: true,
      name: 'GuideDetailPage',
      component: GuideDetailPage,
      requiresTrial: true,
    },
    {
      path: '/ar/the-basics/:slug/:id',
      auth: true,
      name: 'GuideDetailPage',
      component: GuideDetailPage,
      requiresTrial: true,
    },
    {
      path: '/symptoms-tracker',
      auth: true,
      name: 'SymptomsTrackPage',
      component: SymptomsTrackPage,
    },
    {
      path: '/el/symptoms-tracker',
      auth: true,
      name: 'SymptomsTrackPage',
      component: SymptomsTrackPage,
    },
    {
      path: '/en/symptoms-tracker',
      auth: true,
      name: 'SymptomsTrackPage',
      component: SymptomsTrackPage,
    },
    {
      path: '/de/symptoms-tracker',
      auth: true,
      name: 'SymptomsTrackPage',
      component: SymptomsTrackPage,
    },
    {
      path: '/ar/symptoms-tracker',
      auth: true,
      name: 'SymptomsTrackPage',
      component: SymptomsTrackPage,
    },
{
  path: '/moods-tracker',
  auth: true,
  name: 'MoodsTrackPage',
  component: MoodsTrackPage,
},
{
  path: '/el/moods-tracker',
  auth: true,
  name: 'MoodsTrackPage',
  component: MoodsTrackPage,
},
{
  path: '/en/moods-tracker',
  auth: true,
  name: 'MoodsTrackPage',
  component: MoodsTrackPage,
},
{
  path: '/de/moods-tracker',
  auth: true,
  name: 'MoodsTrackPage',
  component: MoodsTrackPage,
},
{
  path: '/ar/moods-tracker',
  auth: true,
  name: 'MoodsTrackPage',
  component: MoodsTrackPage,
},
{
  path: '/my-tracker',
  auth: true,
  name: 'MyTrackPage',
  component: HabitsTrackPage,
  requiresTrial: true,
},
{
  path: '/el/my-tracker',
  auth: true,
  name: 'MyTrackPage',
  component: HabitsTrackPage,
  requiresTrial: true,
},
{
  path: '/en/my-tracker',
  auth: true,
  name: 'MyTrackPage',
  component: HabitsTrackPage,
  requiresTrial: true,
},
{
  path: '/de/my-tracker',
  auth: true,
  name: 'MyTrackPage',
  component: HabitsTrackPage,
  requiresTrial: true,
},
{
  path: '/ar/my-tracker',
  auth: true,
  name: 'MyTrackPage',
  component: HabitsTrackPage,
  requiresTrial: true,
},
{
  path: '/tracker-dashboard',
  auth: true,
  name: 'TrackerDashboardPage',
  component: MenopauseResourcePage,
},
{
  path: '/el/tracker-dashboard',
  auth: true,
  name: 'TrackerDashboardPage',
  component: MenopauseResourcePage,
},
{
  path: '/en/tracker-dashboard',
  auth: true,
  name: 'TrackerDashboardPage',
  component: MenopauseResourcePage,
},
{
  path: '/de/tracker-dashboard',
  auth: true,
  name: 'TrackerDashboardPage',
  component: MenopauseResourcePage,
},
{
  path: '/ar/tracker-dashboard',
  auth: true,
  name: 'TrackerDashboardPage',
  component: TrackerDashboardPage,
},
  ...createLocalizedRoutes({
    path: "/account/personal-settings",
    auth: true,
    name: "PersonalSettingsPage",
    component: PersonalSettingsPage,
    loadData: pageDataLoadingAPI.PersonalSettingPage.loadData,
  }),
      ...createLocalizedRoutes({
    path: "/wellness-programs",
    auth: true,
    name: "WellnessProgramPage",
    component: WellnessProgramPage,
    loadData: pageDataLoadingAPI.WellnessProgramPage.loadData,
    requiresTrial: true,
  }),
    ...createLocalizedRoutes({
    path: "/wellness-program/:id",
    auth: true,
    name: "WellnessProgramDetailsPage",
    component: WellnessProgramDetailsPage,
    requiresTrial: true,
  }),
    ...createLocalizedRoutes({
    path: "/bioiatriki-packages",
    name: "BioiatrikiLandingPage",
    component: BioiatrikiLandingPage,
  }),
  ]
};

export default routeConfiguration;
